export const ar_strings = {
  'smartTable.requestReason': 'سبب الطلب',
  'smartTable.passportType': 'نوع جواز السفر',
  'smartTable.paymentType': 'نوع الدفع',
  'tooltip.allNotes': 'عرض جميع الملاحظات',
  'smartTable.indicatifTelephoneNumber': 'رمز البلد للهاتف',
  'smartTable.phone': 'رقم الهاتف',
  'ask.noTimeSlotBooked': 'لديك طلب بدون موعد. هل تريد حجز موعد الآن؟ هذه الخطوة مطلوبة لإكمال طلبك.',
  'place.warn_closure': 'سيتم إلغاء جميع المواعيد المجدولة في الأيام المغلقة حديثاً لهذا الموقع، وسيتم إخطار المستخدمين المتأثرين. هل تريد المتابعة؟',
  'calendar.mode.open': 'مفتوح بشكل افتراضي',
  'calendar.mode.closed': 'مغلق بشكل افتراضي',
  'calendar.regular_opening_days': 'أيام العمل العادية',
  'calendar.exceptional_opening_days': 'أيام العمل الاستثنائية',
  'calendar.time_ranges': 'النطاقات الزمنية',
  'calendar.from': 'من',
  'calendar.to': 'إلى',
  'calendar.remove_range': 'إزالة',
  'calendar.add_range': 'إضافة نطاق',
  'calendar.confirmReset': 'هل تريد إعادة تعيين جميع الإعدادات الحالية؟',
  'err.pattern.^0[1-9]\\d{6,14}$': 'يجب أن يبدأ الرقم بـ 0، متبوعًا برقم من 1 إلى 9، ثم من 6 إلى 14 رقمًا.',
  'tooltip.openDuplicate': 'فتح آخر دفعة مكررة',
  'payment.openDuplicate': 'فتح المكررة',
  'err.pattern.password': 'يجب أن تحتوي كلمة المرور على عنصرين على الأقل من التالي: حرف صغير، حرف كبير، رقم، أو رمز خاص.',
  'form.perm1.DYN.': 'إنشاء تطبيق',
  'global.pay': 'ادفع',
  'BirthCity': 'مدينة الميلاد',
  'err.pattern.^\\+[1-9][0-9]{7,14}$': 'يجب أن يبدأ الحقل "{fieldName}" بعلامة "+" متبوعة من 8 إلى 15 رقمًا.',
  'err.pattern.^[A-Za-zÀ-ÖØ-öø-ÿ0-9\' .()\\-]*$': 'يجب أن يحتوي الحقل "{fieldName}" على أحرف وأرقام ولهجات ومسافات وعلامات اقتباس ونقاط وأقواس وشرطات فقط.',
  'smartTable.timeslot': 'فترة زمنية',
  'refusalReason.desc.DYN.': '<p>يرجى تقديم وصف موجز لسبب الرفض.</p>',
  'timezone.notice': 'تتم جدولة المواعيد وفقًا للمنطقة الزمنية لمكان الموعد.',
  'timeslot.noBooking': 'لم يتم إجراء حجز لأي وقت.',
  'timeslot.tooCloseToChange': 'لا يمكنك تعديل هذا الموعد بعد الآن لأنه مقرر خلال أقل من {hours} ساعة.',
  'session.inactive.title': 'جلسة غير نشطة',
  'session.inactive': 'انتهت صلاحية جلستك بسبب عدم النشاط',
  'reactivateSession': 'إعادة تنشيط الجلسة',
  'global.changeTimeSlot': 'تغيير الموعد',
  'outUsage.AB': 'هذا الطلب <b>خارج فترة صلاحيته</b>. يرجى توجيه المتقدم إلى الكشك أو مساعدته في إعادة تقديم طلبه.',
  'outUsage.C': 'هذا الطلب <b>خارج فترة صلاحيته</b>. يرجى إغلاق هذا الطلب، ثم إنشاء إدخال جديد للمتقدم والمتابعة بالرفض.',
  'err.payment.notAvailable': 'هذا الطلب غير متوفر.',
  'form.PlaceOfBirth': 'مكان الميلاد',
  'borderPass': 'تصريح حدودي',
  'urgent_pass': 'بطاقة سريعة',
  'feedback': 'الملاحظات',
  'err.mustBeDifferentThan.errorValue': 'يجب أن يكون الحقل "{fieldName}" مختلف عن {errorValue}.',
  'DYN.PASSPORT_WRONG': 'نوع البطاقة المدنية غير صالح',
  'err.max.errorValue': 'يجب أن يكون الحقل "{fieldName}" أصغر من {errorValue}.',
  'err.max': 'يجب أن تكون قيمة الحقل "{fieldName}" أقل من الحد الأقصى المسموح به.',
  'err.min.errorValue': 'يجب أن يكون الحقل "{fieldName}" أكبر من {errorValue}.',
  'err.min': 'جب أن تكون قيمة الحقل "{fieldName}" أكبر من الحد الأدنى المسموح به.',
  'updateField.desc': 'يرجى تقديم المعلومات المحدثة للحقل التالي: <b>{field}</b>',
  'marital.status.engaged': 'متزوج/متزوجة',
  'payment_status.desc.DYN.passport_booked.toPay': 'تم حجز طلب الوثيقة ويجب دفعه بعد.',
  'payment_status.desc.DYN.passport_booked': 'تم حجز طلب الوثيقة ودفعه.',
  'place.notExist': 'المكان غير موجود',
  'ApplicationForm': 'نموذج الطلب',
  'BirthCertificate': 'شهادة الميلاد',
  'ParentalAuthorization': 'الإذن الولي',
  'printSettings.selected': 'أنت تقوم بتعديل إعدادات الطباعة للوثيقة: <b>{documentName}</b>',
  'print.settings.success': 'تم تحديث إعدادات الطباعة بنجاح للوثيقة: <b>{documentName}</b>',
  'error.noHasFace': 'لم يتم اكتشاف أي وجه في الصورة. يرجى إعادة التقاط الصورة.',
  'name.warn': 'الاسم و/أو اللقب فارغ أو يحتوي على أقل من حرفين.',
  'kiosk.redirect': 'جنسيتك لا تسمح بالمتابعة في وضع الكشك. يرجى تسجيل الدخول باستخدام حساب للمتابعة. سيتم تحويلك إلى شاشة تسجيل الدخول.',
  'err.OtherPurpose.required': 'حقل "سبب آخر" مطلوب',
  'print.qr.verification': 'التحقق',
  'print.qr.application': 'طلب',
  'print.terms': 'تطبق الشروط والأحكام.',
  'movements.empty': 'لم يتم تسجيل أي تحركات حتى الآن.',
  'movement.history': 'سجل الدخول والخروج',
  'payment.notes': 'ملاحظات',
  'payment.noNotes': 'لا توجد ملاحظات حالياً',
  'extension.alreadyExists.warning': 'يوجد تمديد بالفعل لهذا الطلب. هل أنت متأكد أنك تريد إنشاء تمديد جديد؟',
  'payment.addNote.placeholder': 'أضف ملاحظة…',
  'payment.addNote.success': 'تمت إضافة الملاحظة بنجاح.',
  'global.seeMore': 'عرض المزيد',
  'global.seeLess': 'عرض أقل',
  'PreviousVisa': 'التأشيرة السابقة',
  'err.PreviousVisa.required': 'الرجاء تقديم التأشيرة السابقة',
  'multipleEntry.warning': 'تنبيه: التأشيرات متعددة الدخول تُمنح فقط للأشخاص الذين حصلوا بالفعل على تأشيرة صالحة واحدة على الأقل في الماضي. سيتم طلب نسخة من التأشيرة السابقة.',
  'downgrade.type.label': 'نوع التأشيرة المستهدفة',
  'ask.downgradeType': 'اختر نوع التأشيرة المستهدفة',
  'err.approveRefuse.required': 'يرجى تحديد ما إذا كنت ترغب في التوصية أم لا.',
  'ask.downgrade.multiple': 'هل أنت متأكد من رغبتك في تخفيض هذه التأشيرة إلى {type}؟',
  'err.hostPhone.pattern': 'يجب أن يبدأ رقم الهاتف بعلامة + (رمز الدولة) أو 0 ويحتوي على ما بين 7 و15 رقمًا.',
  'reprintSticker': 'إعادة طباعة الملصق',
  'err.daysGranted.min': 'عدد الأيام يجب أن يكون على الأقل 1',
  'err.daysGranted.max': 'عدد الأيام لا يمكن أن يتجاوز عدد الأيام المطلوب.',
  'err.daysGranted.required': 'عدد الأيام مطلوب.',
  'approval.daysGranted.error': 'الرجاء إدخال عدد أيام صالح.',
  'err.password.pattern': 'يجب أن تحتوي كلمة المرور على عنصرين على الأقل من التالي: حرف صغير، حرف كبير، رقم، أو رمز خاص.',
  'err.documentNumber.pattern': 'يجب أن يحتوي رقم الوثيقة على أحرف وأرقام ومسافات وشرطات فقط.',
  'err.ExistingValidEntryReference.required': 'مرجع الدخول الصالح الحالي مطلوب',
  'ask.borderpass': 'هل هو حقًا تصريح حدودي؟',
  'BirthCountry': 'الجنسية',
  'old': 'كلمة المرور القديمة',
  'firstName': 'الاسم الأول',
  'email': 'البريد الإلكتروني',
  'paymentMethod': 'طريقة الدفع',
  'client.extended.softLockedOutLogin30Minutes': 'تم إغلاق حسابك لمدة 30 دقيقة. يرجى المحاولة مرة أخرى لاحقًا.',
  'client.extended.tooManyRequests': 'طلبات كثيرة جدًا. يرجى المحاولة مرة أخرى لاحقًا.',
  'password': 'كلمة المرور',
  'password2': 'تأكيد كلمة المرور',
  'PreviousConvictions': 'تحديدات',
  'Address': 'العنوان',
  'DYN.form.documentNumber.scanned': 'رقم المستند {document}',
  'err.err': 'خطأ',
  'err.maxDateMilliFrom.errorValue': 'يجب ألا يتجاوز الحقل "{fieldName}" الحد "{errorValue}" المحدد في الحقل "{control}".',
  'err.maxDateMilliTo.errorValue': 'يجب أن يسبق الحقل "{fieldName}" الحد "{errorValue}" المحدد في الحقل "{control}".',
  'err.mustBeEqualOrAfter.errorValue': 'يجب أن يكون الحقل "{fieldName}" مساوياً أو بعد الحقل "{errorValue}".',
  'err.mustBeEqualOrBefore.errorValue': 'يجب أن يكون الحقل "{fieldName}" مساوياً أو قبل الحقل "{errorValue}".',
  'err.maxDateMilliFromToday.errorValue': 'يجب ألا يتجاوز الحقل "{fieldName}" التاريخ {errorValue}.',
  'err.minDateMilliFromNow.errorValue': 'يجب أن يحتوي الحقل "{fieldName}" على تاريخ يساوي أو بعد {errorValue}.',
  'err.maxDateMilliFromNow.errorValue': 'يجب أن يحتوي الحقل "{fieldName}" على تاريخ يسبق أو يساوي {errorValue}.',
  'err.minDateMilliFromNow': 'يجب أن يحتوي الحقل "{fieldName}" على تاريخ يساوي أو بعد الحد الأدنى المسموح به.',
  'err.maxDateMilliFromNow': 'يجب أن يحتوي الحقل "{fieldName}" على تاريخ يسبق أو يساوي الحد الأقصى المسموح به.',
  'err.mustMatch': 'يجب أن يتطابق الحقل {fieldName} مع الحقل المقابل.',
  'err.requireOneOf.errorValue': '{errorValue} يجب أن يتم توفيره',
  'err.requireOneOf.field': 'الحقل \'{name}\'',
  'err.requireOneOf.separator': ' أو ',
  'err.pattern.^[0-9]{6,14}$': 'يجب أن يحتوي الحقل "{fieldName}" على 6 إلى 14 رقمًا.',
  'err.pattern.^[0-9A-Za-z\\-\\s]{3,15}$': 'يجب أن يحتوي الحقل "{fieldName}" على 3 إلى 15 حرفًا أبجديًا رقميًا أو شرطات أو مسافات.',
  "err.pattern.^[\\p{L}\\p{M}\\p{N}' \\-\\.\\(\\)\\s]+$.errorValue": 'يجب أن يحتوي الحقل "{fieldName}" على أحرف، أرقام، مسافات، فواصل، شرطات، نقاط أو أقواس فقط.',
  "err.pattern.^[\\p{L}\\p{M}' \\-\\.]+$": 'يجب أن يحتوي الحقل "{fieldName}" على أحرف، علامات تشكيل، مسافات، فواصل، شرطات أو نقاط فقط.',
  'err.pattern.^[+]?[0-9\\s\\-\\(\\)]{7,20}$': 'يجب أن يحتوي الحقل "{fieldName}" على 7 إلى 20 رقمًا ويمكن أن يتضمن مسافات، شرطات أو أقواس.',
  'err.pattern.^[0-9A-Za-z]{5,20}$': 'يجب أن يحتوي الحقل "{fieldName}" على 5 إلى 20 حرفًا أبجديًا رقميًا.',
  'err.pattern.^[0-9]{10}$': 'يجب أن يحتوي الحقل "{fieldName}" على 10 أرقام بالضبط.',
  "err.pattern.^[\\p{L}\\p{M}\\p{N}' \\-\\.\\(\\)]*$": 'يجب أن يحتوي الحقل "{fieldName}" على أحرف، تشكيلات، أرقام، مسافات، فواصل، شرطات، أقواس أو نقاط فقط.',
  'err.pattern.^[0-9A-Za-z]{5,20}': 'يجب أن يحتوي الحقل "{fieldName}" على 5 إلى 20 حرفًا أبجديًا رقميًا.',
  'err.pattern.^[\\p{L}\\p{M}\\p{N}\\p{P}\\p{S}\\s]*$': 'يجب أن يحتوي الحقل "{fieldName}" على رموز صالحة فقط.',
  "err.pattern.^[\\p{L}\\p{M}' \\-\\.]*$": 'يجب أن يحتوي الحقل "{fieldName}" على أحرف، تشكيلات، مسافات، فواصل، شرطات أو نقاط فقط.',
  'err.pattern.^[0-9]{8,20}$': 'يجب أن يحتوي الحقل "{fieldName}" على 8 إلى 20 رقمًا.',
  'err.pattern.^[A-Za-z0-9]{5,15}$': 'يجب أن يحتوي الحقل "{fieldName}" على 5 إلى 15 حرفًا أبجديًا رقميًا.',
  'err.pattern.^((?:data:image/(jp2|jpeg);base64,)*([A-Za-z0-9+/==]+))': 'يجب أن يحتوي الحقل "{fieldName}" على صورة بتنسيق JPEG أو JP2 مشفرة بصيغة base64 وبصيغة صالحة.',
  'err.pattern.^[a-z]$': 'يجب أن يحتوي الحقل "{fieldName}" على حرف صغير واحد فقط.',
  "err.pattern.^[A-Z' -]*$": 'يجب أن يحتوي الحقل "{fieldName}" على أحرف كبيرة، فواصل، مسافات أو شرطات فقط.',
  'err.pattern.^[0-9-]{6,15}$': 'يجب أن يحتوي الحقل "{fieldName}" على ما بين 6 و15 حرفًا (أرقام وشرطات فقط).',
  'err.pattern.^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$': 'يجب أن يحتوي الحقل "{fieldName}" على عنوان بريد إلكتروني صالح.',
  'err.pattern.^(?:data:image/(jpeg|png|webp);base64,|data:application/pdf;base64,)*([A-Za-z0-9+/==]+)$': 'يجب أن يحتوي الحقل "{fieldName}" على صورة (JPEG، PNG، WebP) أو ملف PDF مشفر بصيغة base64 بصيغة صالحة.',
  'err.pattern.^[A-Z]{3}$': 'يجب أن يحتوي الحقل "{fieldName}" على ثلاث أحرف كبيرة بالضبط.',
  'err.pattern.^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,9}$': 'يجب أن يحتوي الحقل "{fieldName}" على رقم هاتف صالح مع أو بدون رمز دولي، ويمكن أن يتضمن مسافات، شرطات أو نقاط.',
  'err.pattern.^(?:\\+[1-9]\\d{6,14}|0\\d{6,14})$': 'يجب أن يحتوي الحقل "{fieldName}" على رقم هاتف دولي أو محلي صالح (مثال: +1234567890 أو 0123456789).',
  'err.pattern.^(?:\\+[1-9]\\d{8,9}|0\\d{8,9})$': 'يجب أن يحتوي الحقل "{fieldName}" على رقم هاتف صالح بالتنسيق الدولي (+1234567890) أو المحلي (0123456789)، 9-10 أرقام بعد رمز الدولة.',
  'err.pattern.^[A-Za-z\\s\\-]+$': 'يجب أن يحتوي الحقل "{fieldName}" على أحرف، مسافات أو شرطات فقط.',
  "err.pattern.^[a-zA-Z' -]*$": 'يجب أن يحتوي الحقل "{fieldName}" على أحرف، مسافات أو شرطات فقط.',
  'err.pattern.^[A-Za-z0-9\\s\\-]+$': 'يجب أن يحتوي الحقل "{fieldName}" على أحرف، أرقام، مسافات أو شرطات فقط.',
  "err.pattern.^[\\p{L}\\p{M}' \\-\\.]*$.errorValue": 'يجب أن يحتوي الحقل "{fieldName}" على أحرف، تشكيلات، مسافات، فواصل، شرطات أو نقاط فقط.',
  'err.pattern.^[0-9]*$': 'يجب أن يحتوي الحقل "{fieldName}" على أرقام فقط.',
  'err.pattern.^[0-9]{4}-[0-9]{2}-[0-9]{2}$': 'يجب أن يحتوي الحقل "{fieldName}" على تاريخ صالح.',
  'err.pattern.^[A-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ][a-zA-ZÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒ\\-. ]*$': 'يجب أن يحتوي الحقل "{fieldName}" على أحرف كبيرة أو صغيرة، علامات تشكيل، فواصل، نقاط، شرطات أو مسافات فقط.',
  'err.pattern.^[A-Za-zÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜÆŒàáâãäåçèéêëìíîïòóôõöùúûüæœ\\-. ]*$': 'يجب أن يحتوي الحقل "{fieldName}" على أحرف (مع أو بدون تشكيلات)، مسافات، فواصل، شرطات أو نقاط فقط.',
  'err.pattern.^[A-Z0-9]+$': 'يجب أن يحتوي الحقل "{fieldName}" على أحرف كبيرة وأرقام فقط.',
  'err.pattern.^(?:\\+[1-9]\\d{0,3})$': 'يجب أن يحتوي الحقل "{fieldName}" على رمز "+" متبوعًا بعدد من 1 إلى 4 أرقام (لا يمكن أن يكون الرقم الأول 0).',
  'err.required': 'الحقل "{fieldName}" مطلوب.',
  'err.maxlength.errorValue': 'يجب أن يحتوي الحقل "{fieldName}" على {errorValue} حرفًا كحد أقصى.',
  'err.minlength.errorValue': 'يجب أن يحتوي الحقل "{fieldName}" على {errorValue} حرفًا على الأقل.',
  'err.maxlength': 'الحقل "{fieldName}" طويل جدًا.',
  'err.minlength': 'الحقل "{fieldName}" قصير جدًا.',
  'err.pattern': 'الحقل "{fieldName}" يحتوي على صيغة غير صالحة.',
  'err.email': 'يجب أن يحتوي الحقل "{fieldName}" على عنوان بريد إلكتروني صالح.',
  'form.lang.EN': 'English',
  'form.lang.FR': 'Français',
  'form.lang.AR': 'عربي',
  'form.lang.PT': 'Português',
  'form.lang.DE': 'Deutsch',
  'form.lang.RU': 'Русский',
  'form.lang.CN': '中文',
  'successPayment.booking.title': 'تم تأكيد الحجز!',
  'global.bookTimeSlot': 'حجز موعد',
  'client.extended.maxMonthlyPaymentsReached': 'لقد وصلت إلى أقصى عدد المدفوعات الشهرية. يرجى الاتصال بالدعم.',
  'calendar.weekday.sunday': 'الأحد',
  'calendar.weekday.monday': 'الاثنين',
  'calendar.weekday.tuesday': 'الثلاثاء',
  'calendar.weekday.wednesday': 'الأربعاء',
  'calendar.weekday.thursday': 'الخميس',
  'calendar.weekday.friday': 'الجمعة',
  'calendar.weekday.saturday': 'السبت',
  'calendar.month.january': 'يناير',
  'calendar.month.february': 'فبراير',
  'calendar.month.march': 'مارس',
  'calendar.month.april': 'أبريل',
  'calendar.month.may': 'مايو',
  'calendar.month.june': 'يونيو',
  'calendar.month.july': 'يوليو',
  'calendar.month.august': 'أغسطس',
  'calendar.month.september': 'سبتمبر',
  'calendar.month.october': 'أكتوبر',
  'calendar.month.november': 'نوفمبر',
  'calendar.month.december': 'ديسمبر',
  'calendar.timeline.no_slots': 'لا توجد مواعيد متاحة لهذا اليوم',
  'calendar.timeline.available': 'متاح',
  'calendar.timeline.spots_available': 'أماكن متاحة',
  'calendar.timeline.fully_booked': 'محجوز بالكامل',
  'calendar.confirm_booking_title': 'تأكيد الحجز',
  'calendar.confirm_booking_message': 'يرجى تأكيد أنك تريد حجز هذا الموعد.',
  'calendar.booking_in_progress': 'جارٍ الحجز...',
  'calendar.please_wait': 'يرجى الانتظار بينما نعالج حجزك.',
  'calendar.booking_error_title': 'خطأ في الحجز',
  'calendar.booking_success_title': 'تم تأكيد الحجز!',
  'calendar.booking_success_message': 'تم حجز موعدك بنجاح.',
  'calendar.proceed_to_payment': 'المتابعة للدفع',
  'calendar.auto_proceed_message': 'إعادة توجيه تلقائي خلال...',
  'calendar.date': 'التاريخ',
  'calendar.time': 'الوقت',
  'calendar.place': 'المكان',
  'calendar.loading_month': 'جارٍ تحميل التوفر...',
  'extension.error.maxDays': 'لا يمكنك طلب أكثر من 30 يومًا لكل تمديد.',
  'DYN.processed.NOTICES_ACCEPTED': 'تمت الموافقة على الإشعارات',
  'notices_validated': 'تمت الموافقة على الإشعارات',
  'err.daysUntilReport.pattern': 'يجب أن يكون عدد الأيام حتى التقرير بصيغة صالحة',
  'err.reportInterval.pattern': 'يجب أن يكون فترة التقرير عددًا أكبر أو يساوي 0',
  'err.CompanionsSize.min': 'عدد المصافحات يجب أن يكون على الأقل 1',
  'err.CompanionsSize.max': 'عدد المصافحات طويل جدا',
  'global.error': 'حدث خطأ. يرجى المحاولة مرة أخرى. إذا كان المشكلة مستمرة، يرجى الاتصال بالدعم.',
  'err.DurationOfStay.required': 'المدة المطلوبة',
  'DurationOfStay': 'المدة المطلوبة',
  'err.ModeOfTravel.required': 'وسيلة السفر مطلوبة',
  'err.FlightNumber.required': 'رقم الرحلة مطلوب',
  'err.ShipNumber.required': 'رقم السفينة مطلوب',
  'err.CarNumber.required': 'رقم السيارة مطلوب',
  'err.BusNumber.required': 'رقم الحافلة مطلوب',
  'err.TrainNumber.required': 'رقم القطار مطلوب',
  'err.FlightNumber.pattern': 'رقم الرحلة يجب أن يكون بصيغة صالحة',
  'err.ShipNumber.pattern': 'رقم السفينة يجب أن يكون بصيغة صالحة',
  'err.CarNumber.pattern': 'رقم السيارة يجب أن يكون بصيغة صالحة',
  'err.BusNumber.pattern': 'رقم الحافلة يجب أن يكون بصيغة صالحة',
  'err.TrainNumber.pattern': 'رقم القطار يجب أن يكون بصيغة صالحة',
  'ModeOfTravel': 'وسيلة السفر',
  'FlightNumber': 'رقم الرحلة',
  'ShipNumber': 'رقم السفينة',
  'CarNumber': 'رقم السيارة',
  'BusNumber': 'رقم الحافلة',
  'TrainNumber': 'رقم القطار',
  'DYN.flight': 'رحلة',
  'DYN.ship': 'سفينة',
  'DYN.car': 'سيارة',
  'DYN.bus': 'حافلة',
  'DYN.train': 'قطار',
  'DYN.foot': 'بالمشي',
  'expiredSinceTime': 'انتهت صلاحيتها منذ {days} يوم و {hours} ساعة',
  'visaDocumentsMaxTotalSize': 'يتجاوز الحجم الإجمالي للمستندات التي تم تحميلها الحجم الأقصى المسموح به وهو {size} ميغابايت. يرجى تقليل حجم المستندات والمحاولة مرة أخرى.',
  'payment.consume.placeNotAllowed': 'لا يمكن معالجة هذا الطلب في هذا الموقع. يجب أن ينتقل المسافر إلى أحد المواقع التالية: <br><b>{places}</b>',
  'application.placeAllowed': '<b>قيود الموقع:<b>لا يمكن معالجة هذا المستند إلا في المواقع التالية: <ب>{places}</ب>',
  'paymentUntil.gracePeriod': 'الطلب التالي موجود حاليًا في فترة السماح، والتي تنتهي في <b>{date}</b>. <br><br>يمكنك اختيار ما إذا كان يجب تطبيق رسوم الإقامة الزائدة أم لا.',
  'approval.daysGranted.limit': 'لا يمكن أن يتجاوز عدد الأيام الممنوحة الأيام {days} المطلوبة.',
  'print.alreadyPrinted': 'تمت طباعة مستندات هذا التطبيق آخر مرة في {date} من قبل المستخدم {user}. هل ترغب في طباعتها مرة أخرى؟',
  'participants.desc': 'لرجاء اختيار نفسك و/أو الشخص (الأشخاص) الذي سيكون جزءًا من هذا التطبيق.<br><b>سيتم الدفع في النهاية لجميع الأشخاص المختارين.</b><br><br>بإمكانك إضافة/إزالة شخص أو تعديل طلبه في أي وقت بالضغط على الاسم الذي سيظهر أعلى النموذج.<br><br>{participantText}',
  'dependantIndex': 'التابع {index}',
  'Nationalities': 'الجنسية {index}',
  'alias': 'الأسماء المستعارة {index}',
  'document.number': 'رقم المستند {index}',
  'document.issuer': 'مصدر المستند {index}',
  'document.type': 'نوع المستند {index}',
  'Birthday': 'تاريخ الميلاد {index}',
  'watchlist.image.link': 'رابط الصورة الموجودة {index}',
  'image.match': 'صورة مطابقة {index}',
  'watchlist.match': 'تطابق {numberMatch} | <span class="watchlistCategories">{matchCategory}</span>',
  'batchIds.desc': 'التطبيقات المرتبطة بالمرجع {trip} :',
  'time.day': '{value} اليوم',
  'time.days': '{value} الأيام',
  'time.week': '{value} الأسبوع',
  'time.weeks': '{value} الأسابيع',
  'time.month': '{value} الشهر',
  'time.months': '{value} شهرًا',
  'time.year': '{value} السنة',
  'global.receipt.id': 'معرّف التطبيق: {paymentId}',
  'validate.desc': 'تمت مراجعة طلب التأشيرة هذا على أنه تمت الموافقة عليه في {date} من قبل المستخدم',
  'printEvent.desc': 'تمت طباعة طلب التأشيرة هذا مع جميع مستنداته في {date} من قبل المستخدم',
  'validate.extension.desc': 'تمت مراجعة طلب التمديد هذا على النحو الذي تمت الموافقة عليه في {date} من قبل المستخدم',
  'refusal.review.desc': 'تمت مراجعة طلب التأشيرة هذا باعتباره مرفوضًا في {date} من قبل المستخدم',
  'refusal.review.extension.desc': 'تمت مراجعة طلب التمديد هذا كما تم رفض {date} من قبل المستخدم',
  'refusal.review.desc.blacklisted': 'تمت مراجعة طلب التأشيرة هذا على أنه مرفوض وتم إدراجه في القائمة السوداء {date} من قبل المستخدم',
  'pending.review.desc': 'لقد تم طلب تصحيح طلب التأشيرة هذا إلى مقدم الطلب في {date} من قبل المستخدم',
  'event.downgrade': 'تم تخفيض رتبة هذا التطبيق من <b>{previousPayment}</b> إلى <b>{newPayment}</b> في {date} من قبل المستخدم <b>{userId}</b>.',
  'afterWithoutUntil': 'يُسمح لك بالدخول من {dateAfter} حتى {deadlineDate}.',
  'afterWithoutUntilAndMillis': 'مسموح لك بالسفر من {dateAfter}.',
  'afterAndUntil': 'مسموح لك بالسفر من {dateAfter} حتى {dateUntil}.',
  'localUsageUntil.ask': 'أدخل الأيام (التاريخ الحالي: {calculatedDate})',
  'ask.isArrivalPaid.confirm': 'هل تؤكد أن عملية الدفع قد تمت؟ إذا أكدت ذلك، يُرجى إدخال مرجع الدفع وطريقة الدفع والعملة المستخدمة. يمكنك أيضًا تغيير الحد الأقصى لتاريخ انتهاء الإقامة (يمكنك فقط خفض التاريخ، والاختيار بين 1 و {days} أيام).',
  'ask.localUsageUntil.confirm': 'هنا يمكنك تغيير الحد الأقصى لتاريخ انتهاء الإقامة. يمكنك فقط خفض التاريخ باختيار ما بين 1 و {days} أيام',
  'payment.assigned.warning': 'هذا التطبيق قيد الاستخدام النشط حاليًا من قبل ضابط آخر (الضابط: {officerId}) منذ أقل من 24 ساعة. هل ما زلت تريد فتح هذا التطبيق؟',
  'watchlistCollapse': '<p>قوائم المراقبة الموجودة - <span class="watchlistCategories">{categories}</span></p>',
  'apipnrResponse.match': 'تطابق {numberMatch}',
  'scan.fingerprint.success': 'تم مسح بصمات الأصابع بنجاح. جودة البصمة الممسوحة ضوئياً هي {quality}/100. يمكنك إعادة محاولة العملية إذا كانت الجودة غير كافية.',
  'titlePrint': 'طلب التأشيرة </br> <b>{paymentID}</b>',
  'titlePrint.extension': 'طلب التمديد </br> <b>{paymentID}</b>',
  'welcome.title_1.DYN.': 'مرحبًا بك في {appName}',
  'welcome.text_1.DYN.': 'مرحبًا بك في البوابة الرسمية لـ {appName}.<br>هذا الخدمة الإلكترونية تسهّل عليك الحصول على مستنداتك الرسمية بأمان وسهولة.',
  'welcome.text_1.1.DYN.': 'هل أنت مستعد لمعرفة كيفية العمل؟ لنبدأ!',
  'welcome.title_2.DYN.': 'ما هو {appName}؟',
  'welcome.text_2.DYN.': '{appName} عبارة عن منصة رقمية آمنة تتيح لك طلب مستنداتك الرسمية عبر الإنترنت: بطاقة الهوية، جواز السفر، تصريح الإقامة والمزيد.',
  'welcome.text_2.1.DYN.': 'تقدّم بالطلب من أي مكان وستحصل على مستنداتك عبر البريد الإلكتروني، مع رمز QR فريد يضمن أصالتها.',
  'welcome.title_3.DYN.': 'كعامل',
  'welcome.text_3.DYN.': 'مع {appName} يمكنك إدارة الطلبات دون اتصال. نحن واثقون من أمان وموثوقية طريقتنا في توليد رموز QR.',
  'welcome.text_3.1.DYN.': 'يمكنك أيضًا إدارة المستخدمين والأماكن في مؤسستك.',
  'welcome.text_4.DYN.': 'يمكنك حتى إدارة الطلبات دون اتصال. نحن واثقون من أمان وموثوقية طريقتنا في توليد رموز QR.',
  'welcome.text_4.1.DYN.': 'بمجرد عودتك إلى الاتصال، سيتم مزامنة كل شيء تلقائيًا.',
  'welcome.title_5.DYN.': 'ابدأ طلبك',
  'welcome.text_5.DYN.': 'في الصفحات التالية، يمكنك طلب مستنداتك الرسمية عبر الإنترنت ببضع نقرات فقط.<br><br>بعد الموافقة على طلبك، ستتلقى مستنداتك عبر البريد الإلكتروني مع رمز QR آمن يحتوي على جميع المعلومات اللازمة للتحقق بسرعة وموثوقية.',
  'adminRequestResult.title.DYN.': 'التطبيق المحدد - {paymentID}',
  'tooltip.externalIndexedData': 'تم العثور على جوازات سفر متعددة لهذا الشخص.',
  'DYN.CIV': 'ساحل العاج',
  'customerName': 'اسم العميل',
  'help': 'المساعدة',
  'picture': 'صورة',
  'unlimited': 'غير محدود',
  'download.logs': 'تنزيل السجلات',
  'download.logs.tooltip': 'قم بتنزيل السجلات الكاملة للأنشطة غير المعتادة عبر الإنترنت وغير المتصلة بالإنترنت. سيتم تنزيل هذا الملف بتنسيق JSON ويستخدم بشكل أساسي لأغراض تصحيح الأخطاء.',
  'ask.clear.storage': '<b>سيؤدي هذا الإجراء إلى تنظيف شامل لبيانات الموقع، مشابه لميزة "مسح بيانات الموقع" في Chrome.</b><br>سيتم مسح: localStorage، sessionStorage، IndexedDB، Cache Storage، Service Workers، ملفات تعريف الارتباط، ومخازن أخرى للمتصفح. سيتم تنزيل جميع البيانات التي لا تزال في قائمة الانتظار في ملف JSON قبل مسحها.<br><br>هل أنت متأكد من رغبتك في المتابعة؟',
  'clear.storage': 'مسح المخزن',
  'clear.storage.tooltip': 'مسح جميع البيانات المخزنة محلياً للتطبيق',
  'apply.overstay': 'تطبيق الرسوم',
  'no_apply.overstay': 'بدون رسوم',
  'paymentExtension.overstay': 'هذا الطلب حاليًا في حالة تجاوز مدة الإقامة.<br><br><strong>سعر التمديد الأساسي:</strong> {basePrice}<br><strong>غرامة تجاوز المدة:</strong> {penalty}<br><strong>المجموع مع الغرامة:</strong> {totalPrice}<br><br>يمكنك اختيار ما إذا كان يجب تطبيق رسوم تجاوز المدة أم لا.',
  'consumeMode.transit': 'أنت حاليًا في <b>وضع الترانزيت</b>، ستتم معالجة الطلبات تلقائيًا <b>إلى الداخل والخارج في نفس الوقت</b>. يُستخدم هذا الوضع للمسافرين العابرين الذين هم في حالة عبور ولا يحتاجون إلى البقاء في البلد.',
  'warn.payment.offlineApplication.quit': 'أنت على وشك مغادرة عملية تطبيق غير متصل بالإنترنت. هل أنت متأكد من رغبتك في المتابعة؟ <br><br><b>ستفقد جميع البيانات.</b>',
  'payment_status.desc.offlineApplication': 'تتم معالجة هذا الطلب حاليًا <b>خارج الخط</b>. تابع العملية التي سيتم إرسالها إلى قائمة انتظار المزامنة بمجرد اكتمالها.',
  'continue': 'تابع',
  'global.changePassword': 'تغيير كلمة المرور',
  'signIn.forgotPassword': 'نسيت كلمة المرور',
  'signIn.title': 'تسجيل الدخول',
  'global.notAccount': 'ليس لديك حساب بعد؟',
  'global.continue': 'تابع',
  'Occupation': 'المهنة',
  'signUp.title': 'إنشاء حساب',
  'DYN.selectedPaymentMethod.VISA': 'لقد اخترت الدفع باستخدام <b>Visa</b>.',
  'DYN.selectedPaymentMethod.MASTERCARD': 'لقد اخترت الدفع باستخدام <b>Mastercard</b>.',
  'DYN.selectedPaymentMethod.AMERICAN_EXPRESS': 'لقد اخترت الدفع باستخدام <b>American Express</b>.',
  'DYN.selectedPaymentMethod.DINERS_CLUB': 'لقد اخترت الدفع باستخدام <b>Diner\'s Club</b>.',
  'DYN.selectedPaymentMethod.UNION_PAY': 'لقد اخترت الدفع باستخدام <b>Union Pay</b>.',
  'DYN.selectedPaymentMethod.ZIMSWITCH': 'لقد اخترت الدفع باستخدام <b>Zimswitch</b>.',
  'DYN.selectedPaymentMethod.PAYPAL': 'لقد اخترت الدفع باستخدام <b>PayPal</b>.',
  'DYN.selectedPaymentMethod.DISCOVER': 'لقد اخترت الدفع باستخدام <b>Discover</b>.',
  'ProvisionnalEntryPort': 'نقطة التسجيل المطلوبة',
  'no.must_pay': 'لا يزال الدفع مطلوباً',
  'existingValidEntryReference.desc': 'يحتوي هذا الطلب على <b> مرجع دخول صالح</b>. وهذا يعني أن المسافر قد دفع بالفعل وتم منحه حق الدخول. يرجى التأكد من التحقق من صحة المرجع قبل المتابعة. إذا كان كل شيء صحيحاً، يمكنك متابعة تسجيل الدخول.',
  'ExistingValidEntryReference': 'مرجع الإدخال الصحيح الحالي',
  'supervision.catC.ordinary.entry': 'تسجيل الدخول',
  'supervision.catC.ordinary.refuse': 'مرفوض الدخول',
  'error.updatePassport': 'حدث خطأ أثناء تحديث التطبيق. يرجى المحاولة مرة أخرى.',
  'supervision.login.error': 'فشل في التحقق من المشرف.',
  'open.visaReference': 'فتح التطبيق المرتبط',
  'title.visaReference': 'التطبيق المرتبط',
  'print.extension': 'ملحق الطباعة',
  'documents.load': 'تحميل جميع المستندات',
  'documents.add': 'إضافة مستند مفقود',
  'done.closeApplication': 'تم إغلاق التطبيق بنجاح. هل ترغب في إنشاء تطبيق جديد استنادًا إلى هذا التطبيق',
  'ask.closeApplication': 'يمكن استخدام هذا الإجراء عندما يتمكن المسافر من تقديم دليل على اكتمال العملية دون اتصال بالإنترنت، مما يسمح باعتبار هذا السجل قد تم حله وتجاهله. يرجى تأكيد رغبتك في إغلاق هذا الطلب. هذا الإجراء نهائي ولا يمكن التراجع عنه.',
  'approval.daysGranted.DYN.': 'عدد الأيام الممنوحة',
  'tooltip.printEvents': 'قائمة بجميع أحداث الطباعة لهذا التطبيق',
  'printEventsCollapse': 'جميع أحداث طباعة هذا التطبيق',
  'transactionReference.alt': 'مرجع المعاملات',
  'paymentType.alt': 'طريقة الدفع',
  'changeGender.ask': 'يجب تغيير الجنس في الطلب إلى ذكر أو أنثى.',
  'print.askMultiple': 'هل ترغب في تضمين جميع المستندات ذات الصلة في النسخة المطبوعة؟',
  'application.id': 'معرّف التطبيق',
  'printSticker': 'طباعة ملصق التأشيرة',
  'correctionFields': 'تم تصحيح الحقول التالية:',
  'corrected.desc': 'تم تصحيح طلب التأشيرة هذا من قبل مقدم الطلب في {التاريخ}.',
  'recentlyCorrected': 'تم التصحيح',
  'visaValidFrom': 'الدخول صالح من',
  'visaValidUntil': 'الدخول صالح حتى',
  'online': 'عبر الإنترنت',
  'offline': 'غير متصل بالإنترنت',
  'issuingOfficer.alt': 'ضابط أمن المعلومات',
  'placeOfIssue': 'مكان الإصدار',
  'tooltip.hasBeenCorrected': 'تم تصحيح هذا الطلب من قبل مقدم الطلب.',
  'tooltip.extendStay': 'تمديد إقامة مقدم الطلب',
  'decisionLetter.title': 'خطاب القرار الرسمي بشأن التأشيرة',
  'decisionLetter.approval.title': 'تمت الموافقة على طلب التأشيرة',
  'decisionLetter.refusal.title': 'تم رفض طلب التأشيرة',
  'decisionLetter.applicationId': 'معرف الطلب',
  'decisionLetter.approvalDate': 'تاريخ الموافقة',
  'decisionLetter.refusalDate': 'تاريخ الرفض',
  'decisionLetter.dear': 'السيد أو السيدة',
  'decisionLetter.applicant': 'مقدم الطلب',
  'decisionLetter.documentType.application': 'طلب التأشيرة',
  'decisionLetter.documentType.extension': 'تمديد الإقامة',
  'decisionLetter.approval.body1': 'تمت الموافقة على طلب التأشيرة الخاص بكم.',
  'decisionLetter.approval.body2': 'يرجى تقديم رمز QR المرفق عند وصولكم إلى منفذ الدخول (PoE).',
  'decisionLetter.refusal.body1': 'لم تتم الموافقة على طلب التأشيرة الخاص بكم.',
  'decisionLetter.refusal.body2': 'عند الحاجة، يمكنكم تقديم طلب جديد مع التأكد من معالجة أي أسباب ربما أدت إلى هذا الرفض.',
  'decisionLetter.signature': 'نيابة عن المدير العام للهجرة.',
  'printApprovalLetter': 'طباعة خطاب الموافقة',
  'operation.REFUSEOUT': 'رفض تسجيل المغادرة',
  'operation.REFUSEIN': 'رفض تسجيل الدخول',
  'error.closeApplication': 'حدث خطأ أثناء إغلاق التطبيق. يرجى المحاولة مرة أخرى.',
  'closeApplication': 'وضع علامة مغلق',
  'tooltip.closeApplication': 'ضع علامة على التطبيق على أنه مغلق. هذا الإجراء لا رجعة فيه.',
  'understand': 'أنا أفهم',
  'ExtraDocument1': 'المستند الإضافي رقم 1',
  'ExtraDocument2': 'المستند الإضافي رقم 2',
  'ExtraDocument3': 'المستند الإضافي رقم 3',
  'ExtraDocument4': 'المستند الإضافي رقم 4',
  'ExtraDocument5': 'مستند إضافي رقم 5',
  'paperSize': 'عرض الورق',
  'change_lang': 'تغيير اللغة',
  'queue.export.desc': 'هل ترغب في تصدير قائمة الانتظار الحالية إلى ملف JSON. <b>سيتم حذف قائمة الانتظار المحلية بعد التصدير</b>. هل أنت متأكد أنك تريد المتابعة؟',
  'queue.export': 'التصدير إلى JSON',
  'queue.import': 'قائمة انتظار الاستيراد من JSON',
  'nationality': 'الجنسية',
  'gender': 'الجنس',
  'HQReference': 'مرجع المقر الرئيسي',
  'global.resetDefaults': 'إعادة التعيين إلى الوضع الافتراضي',
  'shortcuts.desc': 'يمكنك تعيين اختصارات لوحة المفاتيح الخاصة بك أدناه. انقر على المفتاح الذي تريد تعيين اختصار جديد له واضغط على المفتاح المطلوب على لوحة المفاتيح.',
  'press.key': 'اضغط على أي مفتاح لتعيين الاختصار...',
  'dashboard.keyboardShortcuts': 'اختصارات لوحة المفاتيح',
  'tooltip.changeShortcuts': 'تغيير اختصارات لوحة المفاتيح',
  'global.changeShortcuts': 'تغيير الاختصارات',
  'retake_picture': 'إعادة التقاط الصورة',
  'error.faceCheck': 'حدث خطأ أثناء معالجة تطابق الوجه. يرجى المحاولة مرة أخرى.',
  'faceCheck.see_score': 'تطابق الوجه',
  'recommendOrNot': 'التوصية أو عدم التوصية',
  'recommended': 'موصى به',
  'not_recommended': 'غير موصى به',
  'error.downgrade': 'حدث خطأ أثناء تخفيض الطلب. يرجى المحاولة مرة أخرى.',
  'done.downgrade': 'تم تخفيض الطلب بنجاح.',
  'request.downgrade': 'تخفيض التصنيف',
  'request.extendStay': 'تمديد الإقامة',
  'ResidencePermitNumber': 'رقم تصريح الإقامة',
  'error.payment.noInternalReference': 'مطلوب مرجع من المقر الرئيسي لمراجعة هذا الطلب. يرجى الانتظار حتى يتم تقديم المرجع.',
  'request.revision': 'هل ترغب في تفعيل ميزة التخطي التلقائي؟ ستعمل هذه الميزة على تخطي الخطوات التي تمت مراجعتها تلقائيًا دون ',
  'notice.BORDER_PASS': 'ممر الحدود',
  'form.borderPassNumber': 'رقم تصريح مرور الحدود',
  'form.dateOfBirth': 'تاريخ الميلاد',
  'form.issueDate': 'تاريخ الإصدار',
  'form.authorizedCrossingPoints': 'نقاط العبور المصرح بها',
  'form.issuedBy': 'صادر عن',
  'form.externalCode': 'الرمز الخارجي (ICAO)',
  'err.invoke': 'خطأ',
  'ask.pendingRequest': 'لديك تصحيح في انتظار التصحيح. هل ترغب في فتحه الآن؟',
  'entry.confirmation': 'هل أنت متأكد من صحة جميع المعلومات المقدمة؟ بالنقر على "تأكيد"، سوف تقوم بإرسال الطلب.',
  'free': 'مجاناً',
  'tooltip.prepareLandingVisa': 'إعداد تأشيرة الهبوط',
  'tooltip.prepareLandingVisa.desc': '<b>تحذير</b>، قد لا تكون هذه التطبيق في الحالة الصحيحة. يرجى التحقق بعناية من المستند المقدم من العميل للتأكد من الحالة الدقيقة لهذا التطبيق. بما أنك في <b>وضع {consumeMode}</b>، لديك خيار <b>فرض المعالجة كـ {transfertMode}</b>، حتى لو لم تكن الحالة الحالية تسمح بذلك عادةً، إذا رأيت أن ذلك ضروري.',
  'last_update': 'آخر تحديث',
  'request.viewOutOfState.button': 'فرض "{consumeMode}"',
  'count': 'العد',
  'tooltip.linkedExtensions': 'هذا تمديد للإقامة. انقر للاطلاع على تفاصيله.',
  'extension': 'التمديد',
  'client.extended.badPaymentMetadata': 'البيانات الوصفية للدفع غير صالحة. يرجى المحاولة مرة أخرى أو الاتصال بالدعم إذا استمرت المشكلة.',
  'DaysRequested': 'الأيام المطلوبة',
  'extensions.desc': 'تمديد (تمديدات) الإقامة في انتظار المراجعة',
  'extend': 'تمديد',
  'CheckboxVisaExtendFees': 'أؤكد أن المعلومات المقدمة صحيحة ودقيقة وأوافق على رسوم تمديد الإقامة والشروط وسياسة الخصوصية.',
  'AttestantDocument': 'الأدلة المستندية',
  'AffidavitCustody': 'إقرار خطي بالحضانة',
  'CopyOfEntry': 'نسخة من الإدخال',
  'DepartureTicket': 'تذكرة المغادرة',
  'DYN.Self': 'ذاتي',
  'DYN.Spouse/Dependent': 'الزوج/الزوج/المعال',
  'DYN.Employee/Employer': 'الموظف/صاحب العمل',
  'DYN.Co-Director': 'مدير مشارك',
  'DYN.Lawyer': 'محامي',
  'VisaReference': 'مرجع التأشيرة',
  'ReasonForExtension': 'سبب التمديد',
  'AttestantID': 'هوية المصدق',
  'AttestantName': 'اسم المصدق',
  'AttestantPhone': 'تصديق الهاتف',
  'AttestantEmail': 'التصديق على البريد الإلكتروني',
  'AttestantAddress': 'عنوان المصدق',
  'AttestantRelation': 'علاقة الشاهد',
  'start_extend': 'تمديد فترة الإقامة',
  'visaExtend.title': 'تمديد البقاء',
  'days': 'أيام',
  'day': 'يوم',
  'kiosk.standby.text1': 'ابدأ بملء الإقرار الخاص بك بنقرات قليلة على هذا الجهاز اللوحي أو عبر الإنترنت.',
  'kiosk.standbyDesc.text1': 'قبل أن تبدأ، يرجى ملاحظة المعلومات التالية :',
  'kiosk.standbyDesc.li1': 'ستقوم بملء نموذج إلكتروني يجمع بياناتك الشخصية وتفاصيل رحلتك.',
  'kiosk.standbyDesc.li2': 'يجب أن تكون جميع المعلومات المقدمة دقيقة ومطابقة لوثائق سفرك (جواز السفر، التأشيرة، إلخ).',
  'kiosk.standbyDesc.li3': 'بعد إكمال الاستمارة، يمكنك التوجه مباشرةً إلى مكتب الهجرة مصطحباً معك وثيقة (وثائق) إثبات الهوية.',
  'kiosk.standbyDesc.li5': 'إذا واجهتك أي صعوبات، فلا تتردد في طلب المساعدة من الموظفين في المركز الحدودي.',
  'kiosk.standbyDesc.text2': 'انقر على "ابدأ" عندما تكون جاهزاً لإكمال إقرار دخولك.',
  'kiosk.success.title': 'تم تقديم الطلب بنجاح',
  'kiosk.success.text1': 'يمكنك الآن التوجّه إلى مكتب الهجرة ومعك وثائق سفرك. سيقوم أحد الضباط بإجراء الفحوصات النهائية والتحقق من صحة دخولك إلى البلد.',
  'kiosk.success.text2': 'إذا كانت لديك أي أسئلة أو صعوبات، فلا تتردد في طلب المساعدة من الموظفين المتاحين.',
  'confirm.revision': 'تأكيد المراجعة',
  'print.isDone': 'هل تمت طباعة الإشعار بنجاح؟ يرجى التأكد من تقديم الإشعار المطبوع إلى مقدم الطلب.',
  'form.hostPhone': 'هاتف المضيف',
  'transit': 'النقل العابر',
  'conditionalEntry': 'الدخول المشروط',
  'departure': 'المغادرة',
  'form.paragraph': 'الفقرة',
  'form.dateOfRefusal': 'تاريخ الرفض',
  'form.purpose': 'الغرض',
  'form.host': 'المضيف',
  'form.officer': 'ضابط',
  'form.reportAt': 'تقرير في',
  'form.reportOn': 'تقرير عن',
  'form.reportInterval': 'فترة التقرير',
  'notice.desc.RESTRICTION': 'يُعلم إشعار التقييد المؤقت مقدم الطلب بالوثيقة (الوثائق) المطلوبة لإكمال العملية. يمكنك تحديد المستند (المستندات) الناقصة التي يجب على مقدم الطلب تقديمها خلال فترة محددة.',
  'notice.REFUSAL': 'إشعار رفض الدخول المرفوض',
  'notice.desc.REFUSAL': 'يتم رفض دخول مقدم الطلب إلى البلاد.',
  'notice.desc.REPORTING': 'يسمح إشعار الزائر لمقدم الطلب بدخول/مغادرة البلد ولكن قد يخضع لمزيد من التقارير. يمكنك تحديد المستندات الناقصة التي يجب على مقدم الطلب تقديمها خلال فترة محددة.',
  'form.stationReference': 'مرجع المحطة',
  'form.fullNames': 'الاسم الكامل',
  'form.reportLocation': 'موقع التقرير',
  'form.daysUntilReport': 'أيام حتى التقرير',
  'form.otherMissingDocument': 'وثيقة أخرى مفقودة',
  'form.residentialAddress': 'العنوان السكني',
  'form.businessAddress': 'عنوان العمل',
  'form.hqReference': 'مرجع المقر الرئيسي',
  'residentPermit': 'تصريح الإقامة',
  'notice.title': 'الإشعارات المتاحة للطباعة',
  'notice.desc': 'يرجى اختيار إشعار من القائمة أدناه. بعد ملء الحقول المطلوبة، يمكنك طباعة الإشعار لمقدم الطلب.',
  'notice.RESTRICTION': 'إشعار التقييد المؤقت',
  'notice.REPORTING': 'إشعار للزائر',
  'notice.RESTRICTION.desc': 'يجب على مقدم الطلب تقديم المستندات الناقصة خلال فترة محددة.',
  'notice.REFUSAL.desc': 'يتم رفض دخول مقدم الطلب إلى البلاد.',
  'notice.REPORTING.desc': 'يُسمح لمقدم الطلب بالدخول ولكن قد يخضع للمزيد من التقارير.',
  'passportType.kioskWarning': 'الجنسية المحددة تندرج تحت نظام الفئة C. يرجى التوجه إلى موظف الهجرة الآن.',
  'free.charge.total': 'المجموع مجاناً',
  'err.entryPoints': 'حدث خطأ أثناء تحميل منافذ الدخول المخطط لها',
  'summary.your_meta': 'بياناتك (انقر للفتح)',
  'summary.payOnline': 'أفضّل الدفع عبر الإنترنت الآن بدلاً من الدفع عند الضابط',
  'summary.payOnline.desc': 'ينقلك تحديد الخيار أدناه إلى صفحة الدفع. إذا اخترت عدم الدفع عبر الإنترنت، يمكنك',
  'summary.meta': 'معلومات (انقر للفتح)',
  'EmergencyLastName': 'الاسم الأخير لجهة الاتصال في حالات الطوارئ',
  'EmergencyFirstName': 'الاسم الأول لجهة الاتصال في حالات الطوارئ',
  'EmergencyEmail': 'البريد الإلكتروني للاتصال في حالات الطوارئ',
  'EmergencyPhone': 'هاتف الاتصال في حالات الطوارئ',
  'person.name': 'شخص مختارشخص مختار',
  'DYN.identity-card': 'بطاقة الهوية',
  'DYN.resident-permit': 'تصريح الإقامة المؤقتة',
  'DYN.identity-card.desc': 'بطاقة الهوية هي وثيقة صادرة عن الحكومة تُستخدم لأغراض تحديد الهوية المحلية.',
  'DYN.resident-permit.desc': 'تصريح الإقامة المؤقتة هو وثيقة رسمية تصدرها الحكومة تسمح لمواطن أجنبي بالإقامة في بلد ما لفترة محددة.',
  'NonOrdinaryPassMission': 'سبب الزيارة الرسمية',
  'PreviousConvictionsHomeAsk': 'هل تمت إدانتك أو إدانة أي من أفراد عائلتك بأي جريمة في بلدك الأصلي؟',
  'PlaceOfBirthCountry': 'بلد الميلاد',
  'PlaceOfBirthCity': 'مدينة الميلاد',
  'OtherName': 'اسم (أسماء أخرى)',
  'travelName': 'مرجع التطبيق',
  'plannedEntry': 'ميناء الدخول المخطط له',
  'summary.title': 'الملخص',
  'urgent': 'عاجل',
  'visaType': 'نوع المستند',
  'passportType': 'نوع التعريف',
  'passportType.acknowledge': 'باختيارك هذا النوع من جوازات السفر، فإنك تقر بأن عدم الامتثال لشروط الاستخدام قد يؤدي إلى رفض دخولك.',
  'passportType.selectRefugeeNationality': 'اختر الجنسية لجواز سفر اللاجئين',
  'form.travelName.already': '<b> تم تقديم هذا الطلب بالفعل مع مرجع الطلب أدناه. إذا كنت ترغب في تغيير المرجع، يرجى بدء تقديم طلب جديد.</b>.',
  'application.current_person': 'أنت تقوم حالياً بتحرير التطبيق الخاص ب',
  'DYN.USD': 'بالدولار الأمريكي',
  'DYN.EUR': 'يورو',
  'smartTable.timeslotPlaceId': 'مكان الفترة الزمنية',
  'DYN.ZWL': 'ZWL',
  'DYN.GBP': 'جنيه إسترليني',
  'DYN.BWP': 'BWP',
  'DYN.KMF': '(KM)F',
  'participants.edit': 'تحرير المتقدمين',
  'request.existSaved': 'تم العثور على تطبيق محفوظ، هل ترغب في تحميل بياناته؟ (إذا نقرت على "لا"، فسيتم حذف التطبيق وستبدأ تطبيقًا جديدًا)',
  'participant.hasData': 'لقد قمت بالفعل بإدخال بيانات هذا المشارك. إذا تابعت، ستفقد البيانات. هل أنت متأكد من رغبتك في المتابعة؟',
  'participant.selectAtLeastOne': 'يرجى تحديد مشارك واحد على الأقل للمتابعة.',
  'participants.title': 'مقدم (مقدمو الطلبات)',
  'participant.ready': '"عندما تكون جاهزًا، انقر فوق "متابعة".',
  'participant.missing': 'قبل المتابعة، يرجى إنشاء شخص واحد على الأقل.',
  'travelName.title': 'مرجع التطبيق',
  'form.travelName': 'مرجع التطبيق',
  'form.travelName.desc': 'سيتم استخدام مرجع التطبيق للتعرف على طلبك بسهولة أكبر.',
  'nationality.title': 'الجنسية',
  'nationality.desc': 'يرجى تحديد بلدك حسب جواز السفر الذي تستخدمه.',
  'passportType.title': 'نوع المستند',
  'passportType.desc': 'يُرجى تحديد نوع وثيقة السفر التي تستخدمها لهذا الطلب.',
  'visaType.title': 'نوع التأشيرة',
  'visaType.desc': 'يُرجى تحديد نوع التأشيرة التي ترغب في التقدم للحصول عليها. تختلف هذه القائمة حسب جنسيتك ونوع جواز سفرك.',
  'urgent.title': 'تأشيرة عادية/عاجلة',
  'urgent.desc': 'إذا كان طلب التأشيرة هذا <b> مستعجلاً، فحدد هذا الخيار. سيكون وقت المعالجة أقصر، ولكن سيتم فرض رسوم إضافية مقابل هذه الخدمة.',
  'priority.normal': 'عادي',
  'priority.urgent': 'عاجل',
  'priority.normal.DYN.desc': 'تتم معالجتها في غضون سبعة (7) أيام عمل.',
  'priority.urgent.DYN.desc': 'تتم معالجتها في غضون ثلاثة (3) أيام عمل.',
  'visa.paidOnArrival.title': 'التأشيرة المدفوعة عند الوصول',
  'visa.paidOnArrival.desc': 'السماح للمسافرين المؤهلين بالحصول على تأشيرة دخول عند الوصول إلى الوجهة ',
  'visa.paidOnline.title': 'دفع التأشيرة عبر الإنترنت',
  'visa.paidOnline.desc': 'يسمح بدخول واحد أو أكثر إلى البلد خلال فترة محددة مدتها شهر واحد (1)، مما يتطلب التأشيرة جديدة للدخول اللاحق.',
  'PassportType': 'نوع جواز السفر',
  'PassportCountry': 'البلد المصدر لجواز السفر',
  'form.passportCountry': 'البلد المصدر لجواز السفر',
  'DYN.ordinary': 'جواز السفر العادي',
  'DYN.diplomatic': 'جواز السفر الدبلوماسي',
  'DYN.official': 'جواز السفر الرسمي',
  'DYN.service': 'جواز سفر الخدمة',
  'supervision.nofee': 'تتطلب طلب بدون غرامة تأكيد من مشرف.',
  'NoFeeProof': 'وثيقة إعفاء من الرسوم',
  'webcam.nofeeProof.confirm': 'يرجى التقاط صورة لوثيقة إعفاء من الرسوم (No Fee Proof).',
  'open.register': 'فتح السجل',
  'DYN.refugee': 'جواز سفر اللاجئين أو وثيقة سفر',
  'DYN.ordinary.desc': 'جواز السفر العادي هو أكثر أنواع جوازات السفر شيوعاً، ويتم إصداره للمواطنين لأغراض السفر العامة.',
  'DYN.diplomatic.desc': 'يتم إصدار جواز السفر الدبلوماسي للدبلوماسيين والقناصل للسفر والإقامة الرسمية في الخارج.',
  'DYN.refugee.desc': 'يتم إصدار جواز سفر اللاجئ من قبل دولة ما للأشخاص الذين تعترف بهم كلاجئين لغرض السفر إلى الخارج.',
  'DYN.official.desc': 'يتم إصدار جواز سفر رسمي لموظفي الحكومة للسفر الرسمي والإقامة في الخارج.',
  'DYN.service.desc': 'يتم إصدار جواز سفر الخدمة لموظفي الحكومة للسفر الرسمي والإقامة في الخارج.',
  'DYN.marine': 'جواز السفر البحري',
  'DYN.marine.desc': 'يتم إصدار جواز السفر البحري للبحارة وأفراد الطاقم للسفر والإقامة في الخارج.',
  'DYN.laissez-passer': 'اجتياز',
  'DYN.laissez-passer.desc': 'جواز السفر هو وثيقة سفر تصدرها الأمم المتحدة أو وكالاتها للسفر والإقامة الرسمية في الخارج.',
  'Urgent': 'هذا طلب عاجل. أفهم أن وقت المعالجة سيكون أقصر، ولكن الرسوم ستكون أعلى.',
  'photo.passport.scanned': 'جواز السفر الممسوح ضوئياً الآن',
  'review.nr.final': 'المراجعة النهائية',
  'review.nr': 'مراجعة رقم',
  'err.ArrivalDate.maxDateMilliTo': 'يجب أن تكون هناك فترة ستة (6) أشهر على الأقل بين تاريخ انتهاء صلاحية جواز سفرك وتاريخ وصولك إلى البلد. يُرجى تجديد جواز السفر هذا قبل تقديم طلب الحصول على تأشيرة.',
  'err.DateOfExpiry.maxDateMilliTo': 'تنتهي صلاحية جواز سفرك بعد أقل من ستة (6) أشهر من تاريخ الوصول إلى البلد. يرجى تجديد جواز السفر هذا قبل تقديم طلب الحصول على تأشيرة.',
  'place.update.error': 'حدث خطأ أثناء تحديث المكان',
  'dashboard.kiosk.start': 'بدء العملية',
  'form.role.kiosk': 'كشك',
  'FundsAvailable': 'المبلغ',
  'FundsAvailableCurrency': 'العملة',
  'emergency_contact_text': 'في حالة الطوارئ، يرجى تقديم تفاصيل الاتصال بشخص يمكن الاتصال به.',
  'emergency_contact': 'جهة اتصال الطوارئ / أقرب الأقارب',
  'err.BirthDay.mustBeEqualOrBefore': 'يجب أن يكون تاريخ الميلاد مساوياً لتاريخ إصدار جواز السفر أو قبله',
  'err.DateOfIssue.mustBeEqualOrAfter': 'يجب أن يكون تاريخ الإصدار مساوياً لتاريخ الميلاد أو بعده',
  'internet.lost': 'انقطع الاتصال بالإنترنت.</br> يرجى التحقق من اتصالك.',
  'err.DateOfExpiry.maxDateMilliFromToday': 'تنتهي صلاحية جواز سفرك بعد أقل من ستة (6) أشهر من اليوم. يرجى تجديد جواز السفر هذا قبل التقدم بطلب للحصول على تأشيرة.',
  'err.DepartureDate.maxDateMilliFrom': 'تاريخ المغادرة بعيد جداً عن تاريخ الوصول. يرجى الرجوع إلى الحد الزمني للتأشيرة.',
  'requirements': 'المتطلبات',
  'err.file.size': 'حجم الملف كبير جداً. الحجم الأقصى هو:',
  'revision.success': 'تم إرسال تحديث طلبك بنجاح. ستتلقى رسالة بريد إلكتروني تحتوي على رمز الاستجابة السريعة بمجرد الموافقة عليه.',
  'revision.free': 'المراجعة المجانية',
  'revision.start': 'لقد حرصنا على ملء الحقول بالمعلومات التي قدمتها في الطلب الأولي، باستثناء الحقول التي تسبب مشاكل. يرجى التحقق من المعلومات وتصحيحها. هل ترغب في المتابعة؟',
  'file_uploaded': 'ملف تم تحميله وتخزينه بالفعل',
  'refusal.desc2': 'تطرح الحقول التالية مشكلة:',
  'start_correction': 'بدء التصحيح',
  'payment.selectMode': 'يرجى تحديد الحقول التي تشكل مشكلة. يمكنك تحديد حقول متعددة.',
  'suspendReason.desc': 'يرجى كتابة وصف موجز لطلب المراجعة. سيتم إرسال هذا الوصف إلى مقدم الطلب مع حقول المشكلة المحددة.',
  'err.ArrivalDate.mustBeEqualOrBefore': 'يجب أن يكون تاريخ الوصول مساوياً لتاريخ المغادرة أو قبله',
  'err.DepartureDate.mustBeEqualOrAfter': 'يجب أن يكون تاريخ المغادرة مساوياً لتاريخ الوصول أو بعده',
  'qr.request_desc': 'يعمل رمز الاستجابة السريعة هذا كبطاقة مرور رقمية لإصدار التأشيرة. وتحتفظ الحكومة بالحق في الموافقة على الدخول أو رفضه وقت مراقبة التأشيرة.',
  'request_state.PENDING': 'قيد الانتظار',
  'document.Screening': 'الفحص',
  'err.SpouseBirthDay.max': 'تاريخ ميلاد الزوج أو الزوجة غير صالح',
  'err.ArrivalDate.min': 'تاريخ الوصول غير صالح',
  'err.DepartureDate.min': 'تاريخ المغادرة غير صالح',
  'err.DateOfIssue.max': 'تاريخ الإصدار غير صالح',
  'err.BirthDay.max': 'تاريخ الميلاد غير صالح',
  'err.dependants_date_of_birth.max': 'معتمد غير صالح ',
  'err.DateOfExpiry.min': 'تاريخ انتهاء الصلاحية غير صالح',
  'dependants': 'المعالون',
  'male': 'ذكر',
  'female': 'أنثى',
  'other': 'أخرى',
  'single': 'مفردة',
  'married': 'متزوج',
  'separated': 'منفصل',
  'divorced': 'مطلقة',
  'widowed': 'أرملة',
  'select_reason_first': 'يرجى تحديد سبب الزيارة في الصفحة السابقة للاطلاع على قائمة المستندات المطلوبة.',
  'visaIntro.title': 'التطبيق',
  'remove': 'إزالة',
  'dependant_add': 'إضافة معتمد',
  'dependant': 'معتمد',
  'upload_file': 'تحميل ملف (< {الحجم})',
  'PassportPhoto': 'صورة وجه حديثة',
  'PassportScan': 'صفحة بيانات السيرة الذاتية لجواز السفر',
  'EventInvitationLetter': 'خطاب دعوة للحدث',
  'ProofOfResidenceHost': 'هوست',
  'AddressAtDestination': 'العنوان في الوجهة',
  'HostInvitationLetter': 'خطاب دعوة المضيف',
  'ProofOfResidence': 'إثبات الإقامة',
  'ApplicationLetter': 'خطاب التقديم',
  'ResidentialStatusOfHost': 'الحالة السكنية للمضيف',
  'ReasonOfVisitProof': 'سبب إثبات الزيارة',
  'BusinessLetter': 'خطاب عمل/خطاب فردي',
  'BusinessProfile': 'الملف التعريفي للأعمال',
  'InvitationLetterAndBusinessProfile': 'رسالة الدعوة ووثائق الشركة المضيفة (موقعة)',
  'InvitationLetter': 'خطاب دعوة',
  'LetterOfAcceptanceFromSchool': 'خطاب التأكيد',
  'DYN.male': 'ذكر',
  'DYN.female': 'أنثى',
  'DYN.other': 'أخرى',
  'DYN.single': 'أعزب',
  'DYN.married': 'متزوج',
  'DYN.separated': 'منفصل',
  'DYN.divorced': 'مطلقة',
  'DYN.widowed': 'أرملة',
  'DYN.married_according_to_custom': 'متزوج وفقًا للعادات',
  'DYN.religiously_married': 'متزوج وفقًا للعادات الدينية',
  'passport.valid': 'لا يبدو أن المستند الممسوح ضوئيًا قد تم التلاعب به أو إبطاله، وهو موقّع من الدولة المُصدرة له.',
  'travel_information_title': 'الإيداع',
  'visaPrice.desc': 'ستُطلب منك إجراء هذا الدفع عبر فيزا أو ماستركارد في نهاية الطلب. هذا الدفع غير قابل للإرجاع.',
  'visaPrice': 'سعر التأشيرة',
  'required': 'مطلوب',
  'DYN.holiday_visa': 'عطلة',
  'DYN.live_here': 'إقامة طويلة المدى',
  'DYN.business_visa': 'الأعمال التجارية',
  'DYN.conferencing_visa': 'مؤتمر',
  'DYN.transit_visa': 'النقل العابر',
  'DYN.student_visa': 'الدراسة',
  'DYN.sports_visa': 'رياضة',
  'DYN.arts_visa': 'فن',
  'DYN.other_visa': 'آخر',
  'DYN.event_visa': 'حدث',
  'document': 'المستند',
  'documents_attached': 'المستندات المطلوب إرفاقها',
  'Dependants': 'المعالون',
  'dependants_name': 'الاسم',
  'dependants_passport_number': 'رقم جواز السفر',
  'dependants_date_of_birth': 'تاريخ الميلاد',
  'dependants_place_of_birth': 'مكان الميلاد',
  'Spouse': 'الزوج',
  'SpouseFullName': 'اسم الزوج',
  'SpousePassportNumber': 'رقم جواز سفر الزوج أو الزوجة',
  'SpouseBirthDay': 'تاريخ ميلاد الزوج أو الزوجة',
  'SpousePlaceOfBirth': 'مكان ميلاد الزوج أو الزوجة',
  'ArrivalDate': 'تاريخ الوصول المتوقع',
  'DepartureDate': 'تاريخ المغادرة المتوقع',
  'ReferencePreviousVisa': 'مرجع التأشيرة السابقة',
  'PreviousConvictionsHome': 'طبيعة الإدانة (الإدانات) في البلد الأصلي',
  'travel_information': 'معلومات السفر',
  'DateOfIssue': 'تاريخ الإصدار',
  'DateOfExpiry': 'تاريخ انتهاء الصلاحية',
  'PlaceofIssue': 'مكان الإصدار',
  'Email': 'البريد الإلكتروني',
  'Phone': 'رقم الهاتف',
  'form.selectCountry': 'اختر دولة',
  'HomeAddress': 'عنوان السكن الحالي',
  'HostName': 'اسم المضيف',
  'InvitingCompanyName': 'اسم الشركة الداعية',
  'form.importantRead': 'مهم - اقرأ بعناية',
  'form.completeInEnglish': 'يجب ملؤه بوضوح باللغة الإنجليزية.',
  'form.selectApplicableFields': 'حدد جميع الحقول المناسبة أدناه.',
  'form.seniority': 'درجة الأقدمية',
  'LastName': 'اسم العائلة',
  'FirstName': 'الاسم (الأسماء) الأولى',
  'BirthDay': 'تاريخ الميلاد (تمامًا كما في جواز السفر)',
  'PlaceOfBirth': 'مكان الميلاد',
  'Gender': 'الجنس',
  'MaritalStatus': 'الحالة الاجتماعية',
  'CheckboxVisaFees': 'أؤكد أن المعلومات المقدمة صحيحة ودقيقة وأوافق على رسوم التأشيرة وشروطها وسياسة الخصوصية.',
  'PassportNumber': 'رقم جواز السفر',
  'Nationality': 'الجنسية',
  'err.nationality.required': 'الجنسية مطلوبة.',
  'PurposeOfVisit': 'الغرض من الزيارة',
  'VisaType': 'نوع التأشيرة',
  'visitor_details': 'تفاصيل مقدم الطلب',
  'personal_details': 'التفاصيل الشخصية',
  'contact_details': 'تفاصيل الاتصال',
  'miscellaneous_details': 'تفاصيل السفر',
  'spouse_details': 'تفاصيل الزوج/الزوجة',
  'payment': 'الدفع',
  'global.scan_qr': 'التحقق من رمز الاستجابة السريعة',
  'qr.nosuch': 'جاري التحميل... لم يتم العثور على رمز الاستجابة السريعة في النظام بعد. تحقق من الاتصال بالإنترنت.',
  'qr.faked': 'رد الخادم هو رمز الاستجابة السريعة غير موجود. من المحتمل جداً أن يكون مزيفاً!',
  'qr.quicklook': 'معلومات أساسية',
  'global.toPayments.DYN.': 'عرض الطلبات',
  'payment.duplicate.open': 'افتح الدفعة الجديدة ?',
  'ONE_DAY': '1 يوم واحد',
  'THREE_DAYS': '3 أيام',
  'ONE_WEEK': '1 أسبوع',
  'TWO_WEEKS': '2 أسبوعان',
  'ONE_MONTH': '1 شهر',
  'TWO_MONTHS': '2 شهران',
  'SIX_MONTHS': '6 أشهر',
  'ONE_YEAR': '1 سنة',
  'place_created.desc': 'تم إنشاء المكان الجديد وهو الآن صالح للاستخدام.',
  'payment_status.DYN.NONE': '-- لا يوجد مرشح --',
  'dropdown.state': 'الحالة',
  'payment.qrList.title': 'قائمة مدفوعات الاستجابة السريعة',
  'see.qr_list': 'اطلع على قائمة رموز الاستجابة السريعة',
  'form.role.partner_registrer': 'سجل الشركاء',
  'form.reason': 'السبب',
  'global.reject': 'رفض',
  'payment.validate_desc': 'هل أنت متأكد من رغبتك في التحقق من صحة هذه الدفعة؟',
  'payment.reject_desc': 'هل أنت متأكد من رغبتك في رفض هذه الدفعة؟ دون ',
  'qr.title': 'رمز الاستجابة السريعة',
  'dashboard': 'لوحة التحكم',
  'dashboard.people.DYN.': 'أشخاص الذين تم حفظهم',
  'dashboard.my_account': 'حسابي',
  'form.refunded_date': 'تاريخ الاسترداد',
  'form.enter_message': 'أدخل الرسالة',
  'form.end_date': 'تاريخ الانتهاء',
  'form.start_date': 'تاريخ البدء',
  'form.search_anything': 'ابحث عن أي شيء',
  'form.invalid_end_date': 'تاريخ انتهاء الصلاحية غير صالح',
  'form.invalid_start_date': 'تاريخ البدء غير صالح',
  'smartTable.isDelayed': 'متأخر',
  'form.id': 'بطاقة الهوية',
  'payments.scan': 'مسح QR',
  'print.qr.desc': 'هذا رمز QR فريد وآمن، ولا يمكن استخدامه إلا بعدد المرات المحدد. لا تُعدّل عليه لكي يبقى صالحًا للاستخدام.',
  'print.qr.title': 'رمز الاستجابة السريعة',
  'print.informations': 'المعلومات',
  'print.notice.folding': 'تعليمات الطي',
  'print.notice.desc2': 'في حالة وجود أي سؤال يتعلق بهذا المستند، يُرجى الاتصال بالدعم عبر الهاتف أو البريد الإلكتروني.',
  'print.notice.desc1': 'احفظ هذا المستند بعيداً عن الماء أو اللهب.',
  'print.notice.title': 'إشعار',
  'client.extended.openSuchPayment': 'الدفعة نشطة بالفعل تحت هذا المستخدم',
  'form.externalId': 'مرجع الدفع',
  'form.userExternalId': 'المعرف الخارجي',
  'global.confirm': 'تأكيد',
  'global.submit': 'إرسال',
  'global.back': 'رجوع',
  'global.close': 'إغلاق',
  'global.contact_support': 'اتصل بالدعم',
  'global.previous': 'السابق',
  'global.next': 'التالي',
  'global.accept': 'قبول',
  'global.support': 'الدعم',
  'global.consume': 'استهلك',
  'global.validate': 'التحقق من صحة',
  'global.reset': 'إعادة تعيين',
  'global.delete': 'حذف',
  'global.update': 'تحديث',
  'global.download': 'تنزيل',
  'global.print': 'الطباعة',
  'global.print_c7': 'طباعة التذكرة',
  'global.checkIn': 'تسجيل الوصول',
  'choose-lang.title': 'تفضيل اللغة',
  'choose-lang.desc': 'يرجى اختيار اللغة التي سيتم استخدامها لهذا الطلب.',
  'global.personalNum': 'عدد الموظفين',
  'global.passportNum': 'رقم جواز السفر',
  'global.add': 'إضافة',
  'global.block': 'المربع',
  'global.blocked': 'بلوكيد',
  'global.unblock': 'إلغاء الحظر',
  'global.daily_otp': 'الرمز اليومي',
  'global.refresh': 'تحديث',
  'global.connect': 'الاتصال',
  'global.disconnect': 'قطع الاتصال',
  'form.email': 'البريد الإلكتروني',
  'form.name': 'الاسم',
  'form.firstName': 'الاسم (الأسماء) الأولى',
  'form.lastName': 'اسم العائلة',
  'form.password': 'كلمة المرور',
  'form.password2': 'إعادة كتابة كلمة المرور',
  'form.linkType': 'ما هي علاقة هذا الشخص معك',
  'form.userId': 'معرّف المستخدم',
  'form.parentId': 'هوية الوالدين',
  'form.amount': 'المبلغ',
  'form.currency': 'العملة',
  'form.buyingOption': 'وثيقة تم شراؤها',
  'form.place': 'المكان',
  'form.role': 'الدور',
  'form.connectUAPattern': 'نمط وكيل المستخدم',
  'form.connectIPRange': 'نطاق IP',
  'form.state': 'الولاية',
  'form.created_date': 'تاريخ الإنشاء',
  'form.created_place': 'مكان الإنشاء',
  'form.consumed_place': 'مكان مستهلك',
  'form.email_code': 'الرمز من البريد الإلكتروني',
  'form.phone': 'رقم الهاتف',
  'form.worker': 'هوية الموظف',
  'form.password_old': 'كلمة المرور الحالية',
  'form.password_new': 'كلمة مرور جديدة',
  'form.idCard': 'رقم بطاقة الهوية',
  'form.type.CASH': 'نقداً',
  'form.type.CARD': 'البطاقة',
  'form.role.customer': 'العميل',
  'form.role.worker': 'عامل',
  'yes': 'نعم',
  'no': 'لا',
  'form.borderPass': 'إصدار تصريح مرور الحدود',
  'form.role.orbis_consumer': 'مستهلك أوربيس',
  'form.role.admin': 'المسؤول',
  'form.perm2.DYN.': 'استهلك طلب',
  'form.perm3.DYN.': 'مراجعة طلب',
  'form.perm4.DYN.': 'إنشاء/إدارة الأماكن والمستخدمين وطلبات التأشيرات',
  'client.extended.clientNotAllowed': 'حسابك غير مسموح به حالياً في هذا المكان. يرجى التحقق من إعدادات الاتصال الخاصة بك.',
  'err.submit': 'خطأ في تقديم النموذج',
  'err.place.required': 'المكان مطلوب',
  'err.noSmsPerm': 'لم يتم منح حق الرسائل النصية القصيرة',
  'err.noSmsReceive': 'لا يمكن الربط بمحاضرة SMS',
  'helps.showProceed': 'تابع العرض',
  'helps.showScan': 'إظهار مستند المسح الضوئي',
  'payment_status.DYN.undefined': 'الحالة الحالية - ليست عملية',
  'client.extended.missingResourceLogin': 'تعذر الاتصال، بيانات اعتماد خاطئة',
  'client.extended.linkedAccountExists': 'الحساب بهذا البريد الإلكتروني موجود بالفعل',
  'client.extended.attachedPayments': 'لا يمكنك تعديل هذا الشخص، فقد تم إنشاء تطبيق مرتبط به بالفعل.',
  'client.extended.badPayload': 'معلومات خاطئة في الطلب',
  'client.extended.placeNotAllowed': 'المكان غير مسموح به',
  'client.extended.locked': 'الحساب مغلق',
  'client.extended.clientBadOtp': 'الرمز اليومي السيئ',
  'client.extended.confirmationRequired': 'التأكيد مطلوب',
  'confirmationRequired.email': 'تم إرسال رابط التأكيد إلى بريدك الإلكتروني. يرجى التحقق من صندوق الوارد والتأكيد قبل تسجيل الدخول.',
  'confirmationRequired.sms': 'تم إرسال رابط التأكيد عبر رسالة نصية. يرجى التحقق من رسائلك والتأكيد قبل تسجيل الدخول.',
  'client.extended.badPaymentConfirmation': 'لا يمكن متابعة الدفع: فشل أحد عمليات التحقق',
  'time': 'الوقت',
  'place': 'المكان',
  'home.first': 'تم التحقق من صحة حسابك الآن ويمكنك تسجيل الدخول.',
  'payOnline': 'الدفع عبر الإنترنت',
  'login.sign_in': 'تسجيل الدخول',
  'photo.unavailable': 'الصورة غير متوفرة',
  'global.entry': 'الدخول',
  'global.exit': 'الخروج',
  'menu.users': 'المستخدمون',
  'menu.places': 'الأماكن',
  'create_user.title': 'إنشاء مستخدم',
  'create_payment.title': 'إنشاء دفعة',
  'create_place.title': 'إنشاء مكان',
  'users.title': 'قاعدة بيانات المستخدمين',
  'payments.title': 'قاعدة بيانات المدفوعات',
  'payments.download_csv': 'تنزيل ملف CSV',
  'create_card_payment.title': 'الدفع عبر الإنترنت',
  'places.title': 'قائمة الأماكن',
  'forgot_password.title': 'إعادة تعيين كلمة المرور',
  'payment_status.DYN.PROPOSED': 'في انتظار السداد',
  'payment_status.DYN.PAID': 'جاهز لتسجيل الوصول',
  'payment_status.DYN.PAID_NOT_CONFIRMED': 'في انتظار المراجعة',
  'payment_status.DYN.USED': 'تم تسجيل المغادرة',
  'payment_status.DYN.DUPLICATED': 'مكررة',
  'payment_status.DYN.REFUNDED': 'مستردة',
  'payment_status.DYN.EXPIRED': 'مرفوض',
  'payment_status.DYN.PENDING': 'في انتظار التصحيح',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED': 'الدفع لاحقاً - غير مؤكد',
  'payment_status.DYN.DELAY_PAY_NOT_CONFIRMED.FREE': 'مجاناً - غير مؤكد',
  'payment_status.DYN.DELAY_PAY': 'جاهز للدفع عند الوصول',
  'payments.validate': 'تأكيد',
  'documentContinue.title': 'مواصلة التسوق',
  'bt.available_devices': 'أجهزة البلوتوث المتوفرة',
  'bt.no_available_devices': 'لم يتم اكتشاف أي أجهزة بلوتوث متوفرة',
  'emailSend.title': 'التحقق من البريد الإلكتروني',
  'emailSend.description': 'من أجل التحقق من صحة حسابك، يجب عليك النقر على الرابط الموجود في رسالة التحقق المرسلة إلى عنوان بريدك الإلكتروني في غضون 24 ساعة.',
  'emailValid.title': 'تم التحقق من صحة الحساب',
  'emailValid.description': 'تم التحقق من صحة حسابك {اسم التطبيق} بنجاح. يمكنك الآن الوصول إلى مساحتك الشخصية عن طريق تسجيل الدخول باستخدام بيانات الاعتماد الخاصة بك.',
  'documentManagement.title': 'طلب التأشيرة',
  'preenroll.title': 'التسجيل المسبق',
  'passportEmbassy.title': 'وثيقة السفارة',
  'zwevisa.title': 'التأشيرة',
  'passwordSend.title': 'تم إرسال التأكيد',
  'passwordSend.description': 'لقد تلقيت رسالة تأكيد بالبريد الإلكتروني تحتوي على رابط لإعادة تعيين كلمة المرور الخاصة بك. لديك 24 ساعة للنقر عليه.',
  'forgotPassword.title': 'نسيت كلمة المرور',
  'forgotPassword.description': 'لإعادة تعيين كلمة المرور الخاصة بك، أدخل البريد الإلكتروني لحسابك أدناه.',
  'forgotPassword.description.electron': 'لإعادة تعيين كلمة المرور الخاصة بك، أدخل البريد الإلكتروني لحسابك أدناه. إذا كنت تحاول استرداد كلمة مرور لحساب "دليل نشط"، يُرجى الاتصال بالدعم.',
  'passwordNew.title': 'كلمة مرور جديدة',
  'modifiedPassword.title': 'تغيير كلمة المرور',
  'modifiedPassword.description': 'تم تغيير كلمة المرور. يرجى تسجيل الدخول مرة أخرى.',
  'people.title.DYN.': 'الأشخاص الذين تم إنقاذهم',
  'people.addPerson.DYN.': 'إنشاء شخص جديد',
  'meansPayment.title': 'وسائل الدفع',
  'onlinePayment.title': 'الدفع عبر PayPal',
  'onlinePayment.pay': 'الراتب',
  'qrPayment.title': 'الدفع عن طريق رمز الاستجابة السريعة',
  'form.expireDate': 'تاريخ انتهاء الصلاحية',
  'successPayment.title': 'تأكيد الطلب',
  'trackingControl.title.DYN.': 'تتبع هذا التطبيق',
  'modifyData': 'تعديل البيانات',
  'stopModifyData': 'إيقاف تعديل البيانات',
  'askVisa': 'اطلب التأشيرة',
  'peopleNew.title.DYN.': 'شخص جديد',
  'peopleFound.title.DYN.': 'الشخص الذي تم العثور عليه',
  'peopleFound.description.DYN.': 'تمت إضافة الشخص المطابق للمعلومات التي أدخلتها إلى قائمة الأشخاص المحفوظين.',
  'payment.commandHistory': 'تاريخ الدفع',
  'menu.placesPerm': 'الأماكن والأذونات',
  'block.message': 'هل تريد حظر هذا المستخدم؟',
  'menu.addPlace': 'إضافة مكان',
  'label.numberAccount': 'رقم الحساب',
  'place.sheet.open': 'افتح المكان ',
  'place.delete': 'هل أنت متأكد من رغبتك في حذف هذا المكان؟ هذا الإجراء لا رجعة فيه.',
  'place.update.success': 'تم تحديث المكان بنجاح.',
  'place.new': 'مكان جديد',
  'place.create': 'إنشاء مكان',
  'place.add.ask': 'هل تريد ربط هذا الموقع بهذا المستخدم؟',
  'place.delete.link': 'احذف الرابط مع هذا المكان',
  'place.delete.link.ask': 'هل أنت متأكد من أنك تريد إلغاء ربط هذا المكان؟',
  'place.delete.link.done': 'لقد نجحت في إزالة الرابط مع المكان.',
  'user.new': 'مستخدم جديد',
  'user.create': 'إنشاء المستخدم',
  'user.created': 'تم إنشاء المستخدم الجديد بنجاح. يمكن الآن استخدام هذا الحساب.',
  'user.sheet.open': 'افتح المستخدم ',
  'payment.sheet.open': 'افتح الدفعة ',
  'err.createplace': 'غير قادر على الإنشاء. المعرف موجود بالفعل.',
  'place.parent': 'مكان الوالدين',
  'dropdown.qr': 'مسح رمز الاستجابة السريعة ضوئياً',
  'dropdown.pass': 'مسح مستند ضوئياً',
  'info.testingReader': 'التحقق من وجود القارئ...',
  'info.testingReaderCard': 'اختبار ما إذا كان القارئ لديه بطاقة متقطعة...',
  'info.readingMrz': 'قراءة MRZ...',
  'info.connecting': 'الاتصال بالشريحة...',
  'info.testingBAC': 'تنفيذ التحكم في الوصول الأساسي...',
  'info.readingCertificate': 'قراءة شهادة التوقيع...',
  'info.doingPA': 'إجراء المصادقة السلبية...',
  'info.readingDG': 'قراءة مجموعات البيانات...',
  'info.disconnect': 'قطع الاتصال...',
  'info.convertingImage': 'تحويل الصورة المقروءة من المستند...',
  'info.searchingPayment': 'البحث عن تطبيق في الخوادم...',
  'info.readingPayment': 'قراءة المعلومات التفصيلية من الخادم...',
  'err.noReader': 'القارئ غير متصل. يرجى توصيل القارئ للمتابعة.',
  'err.noCard': 'لم يتم اكتشاف مستند بيومتري صالح في القارئ. قد يكون ذلك بسبب استخدام مستند غير بيومتري أو تقديم نسخة غير مصرح بها أو مزيفة أو عطل في هوائي القراءة.',
  'err.noConnect': 'لا يستجيب هذا المستند لبروتوكولات منظمة الطيران المدني الدولي القياسية. قد يكون ذلك بسبب استخدام وثيقة غير بيومترية أو تقديم نسخة غير مصرح بها أو مزورة أو عطل في هوائي القراءة.',
  'err.noBAC': 'تعذر إنشاء قناة آمنة للوثيقة، هل هي أصلية؟ تحقق من هذه الوثيقة يدوياً بشكل مكثف واستجوب حاملها.',
  'err.alteredDoc': 'تعذر قراءة حقول المستند، هل هو أصلي؟ تحقق من هذه الوثيقة يدوياً بشكل موسع واستجوب حاملها.',
  'err.revokedDocSigner': 'تم إبطال توقيع هذه الوثيقة من قبل السلطة التي أصدرتها. ربما تم توقيع هذه الوثيقة عن طريق الاحتيال. استجوبوا حاملها باستفاضة حول هذا الأمر.',
  'err.unverifiedDoc': 'تعذر التحقق من صلاحية المستند، أو وجود خطأ في بروتوكول المصادقة، وقد يكون ذلك علامة على وجود مستند صادر خارج البلد وفقًا للقائمة الرئيسية لمنظمة الطيران المدني الدولي أو مستند مزور أو عطل في هوائي القراءة.',
  'err.noPassiveAuthentication': 'تعذّر التحقق من صحة المستند، أو تعذّر التحقق من صحة المستند، أو وجود خطأ في بروتوكول المصادقة، أو مستند مزيف، أو عطل في هوائي القراءة.',
  'err.noResult': 'لم يتم العثور على ملف',
  'payment.new.DYN.': 'خروج جديد بدون تأشيرة',
  'payment.created.register': 'المدفوعات المسجلة',
  'payment.created': 'تم حفظ دفعتك وأصبحت الآن مرئية في قائمة المدفوعات.',
  'payment.created.qr': 'تم إرسال رسالة بريد إلكتروني تحتوي على رمز الاستجابة السريعة الذي تم إنشاؤه إلى عنوان البريد الإلكتروني المقدم.',
  'idcard.number': 'رقم بطاقة الهوية',
  'form.userCreator': 'تم إنشاؤها بواسطة المستخدم',
  'form.userRefund': 'تسدد من قبل المستخدم',
  'form.userConsumed': 'يستهلكها المستخدم',
  'PRICEUP': 'السعر 0-9',
  'PRICEDOWN': 'السعر 9-0',
  'RECENT': 'الأحدث',
  'LATEST': 'الأقدم',
  'STATUSUP': 'الحالة من أ إلى ياء',
  'STATUSDOWN': 'الحالة ض-أ',
  'payment.success': 'تم تسجيل الدفع الخاص بك',
  'payment.consume.ask.DYN.': 'هل تريد حقاً تسجيل الدخول/الخروج من طلب هذا؟',
  'checkinOut.refuse': 'هل تريد حقاً رفض هذا الطلب؟',
  'payment.duplicate': 'تكرار',
  'payment.duplicate.ask': 'هل تريد حقاً تكرار هذه الدفعة؟',
  'payment.duplicate.done': 'تم تكرار دفعتك بنجاح',
  'tooltip.duplicatePayment': 'تكرار هذا الدفع للسماح بإعادة استخدامه',
  'payment.refund.ask': 'هل تريد حقًا استرداد هذه الدفعة؟',
  'payment.refund.done': 'تم استرداد المبلغ الذي دفعته بنجاح',
  'payment.refund.exist': 'تم استرداد هذه الدفعة بالفعل',
  'payment.paid.error': 'يجب أن يكون الدفع الخاص بك على الحالة ',
  'block.done': 'تم حظر الحساب',
  'block.unblock': 'تم إلغاء حظر الحساب',
  'place-add.add': 'إضافة مكان',
  'permission.title': 'الإذن مطلوب: كاميرا',
  'qr.see': 'انظر رمز الاستجابة السريعة',
  'qr.desc.DYN.': 'إليك رمز الاستجابة السريعة للتطبيق. سيظهر أثناء الطباعة وسيتم إرساله إلى عنوان البريد الإلكتروني الذي تم إدخاله أثناء التسجيل.',
  'dashboard.place.verif': 'إذا لم تكن قد قمت بإدخال موقع، يرجى القيام بذلك',
  'block.yourself': 'يمكنك',
  'lastPlace.delete': 'المكان الأخير في هذا الحساب على وشك الحذف. سيؤدي ذلك إلى جعل هذا الحساب غير قابل للاستخدام. متابعة؟',
  'place.add.done': 'تمت إضافة هذا المكان إلى هذا المستخدم بنجاح',
  'no.connection': 'للوصول إلى هذه الصفحة، يجب أن تكون متصلاً بالإنترنت. يرجى تسجيل الدخول مرة أخرى',
  'place.delete.success': 'تم حذف هذا المكان.',
  'wrong.current': 'لقد أدخلت كلمة مرور حالية خاطئة',
  'no.place': 'لا مكان لهذا الحساب.',
  'email.error': 'يوجد بريد إلكتروني مماثل بالفعل',
  'email.notexist': 'البريد الإلكتروني غير موجود',
  'one.payment': 'يجب أن يكون لديك على الأقل دفعة واحدة أو أكثر تم إنشاؤها و/أو تصفيتها.',
  'err.client.extended.uuidUsed': 'تم استهلاك هذه الدفعة بالفعل',
  'client.extended.uuidUsed': 'تم استهلاك هذه الدفعة بالفعل',
  'no.activecamera': 'لم يتم العثور على كاميرا نشطة',
  'no.accessPermission': 'لا يحتوي هذا الحساب على إذن وصول',
  'print.name': 'الطابعة',
  'print.success': 'تمت طباعة تذكرتك',
  'print.need': 'يجب عليك أولاً الاتصال بطابعة لتتمكن من الطباعة',
  'printer.connect': 'أنت الآن متصل بالطابعة:',
  'permission.desc': 'تتطلب الخدمة التي ترغب في استخدامها إذنًا لاستخدام جهازك ',
  'createPeople.ask.DYN.': 'هل تريد حقًا إنشاء هذا الشخص الجديد؟',
  'createPeopleDuplicate.ask.DYN.': 'يبدو أن هناك شخص بنفس الاسم موجود بالفعل في الأشخاص المسجلين لديك. هل ما زلت تريد إنشاء هذا الشخص؟',
  'deletePerson.DYN.': 'حذف هذا الشخص',
  'deletePerson.ask.DYN.': 'هل أنت متأكد أنك تريد حذف هذا الشخص؟',
  'deletePerson.valid.DYN.': 'تم حذف الشخص',
  'personModification.ask.DYN.': 'هل أنت متأكد أنك تريد تغيير هذا الشخص ',
  'personModification.valid.DYN.': 'الشخص ',
  'noPayment': 'لا توجد مدفوعات',
  'selfie.desc': 'مطلوب صورة لطلب المستند، يُرجى التأكد من أن الصورة في إضاءة جيدة وأن تمسك هاتفك بثبات لتجنب الصورة الباهتة. تأكد أيضاً من ظهور جميع تفاصيل وجهك بوضوح في الصورة.',
  'ZWEVISA.title': 'التأشيرة',
  'EMBASSYPASS.title': 'جواز سفر السفارة',
  'PREENROLL.title': 'التسجيل المسبق',
  'DYN.NOK': 'تم رفض الطلب',
  'WIP': 'العمل قيد التنفيذ',
  'menu.requests.DYN.': 'التطبيقات',
  'menu.createRequests.DYN.': 'تطبيق جديد',
  'request_state.SUBMITTED': 'تم التقديم',
  'request_state.CONFIRMED': 'تم التأكيد',
  'request_state.TREATED': 'معالجتها',
  'request_state.TRANSFERRED': 'منقولة',
  'request_state.CANCELLED': 'تم الإلغاء',
  'request_state.REFUSED': 'مرفوض',
  'request_state.UNUSABLE': 'غير قابل للاستخدام',
  'request_state.NULL': 'غير مدفوعة',
  'request_state.NONE': '-- لا يوجد مرشح --',
  'ask.disconnect': 'هل أنت متأكد من رغبتك في قطع الاتصال؟',
  'global.yes': 'نعم',
  'applicant.gender.male': 'ذكر',
  'applicant.gender.female': 'أنثى',
  'applicant.gender.other': 'أخرى',
  'marital.status.single': 'مفردة',
  'marital.status.married': 'متزوج',
  'marital.status.separated': 'منفصل',
  'marital.status.divorced': 'مطلقة',
  'marital.status.widowed': 'أرملة',
  'marital.status.religiously_married': 'متزوجة دينيًا',
  'marital.status.married_according_to_custom': 'متزوجة حسب العرف',
  'marital.status.other': 'أخرى',
  'marital.status.unknown': 'غير معروف',
  'request_state.PROPOSED': 'في انتظار السداد',
  'request_state.PAID': 'مكتمل',
  'request_state.USED': 'مغلق',
  'request_state.DUPLICATED': 'مكررة',
  'request_state.REFUNDED': 'مستردة',
  'request_state.EXPIRED': 'مرفوض',
  'request_state.PAID_NOT_CONFIRMED': 'في انتظار المراجعة',
  'request_state.DELAY_PAY_NOT_CONFIRMED': 'الدفع لاحقاً - غير مؤكد',
  'request_state.DELAY_PAY': 'جاهز للدفع عند الوصول',
  'payment_status.DYN.0': 'في انتظار السداد',
  'payment_status.DYN.1': 'جاهز لتسجيل الوصول',
  'payment_status.DYN.6': 'في انتظار المراجعة',
  'payment_status.DYN.2.9': 'في انتظار الإشراف',
  'payment_status.DYN.2.10': 'تحت الإشراف',
  'payment_status.desc.DYN.2.10': 'تمت مراجعة الطلب من قِبل أحد المشرفين وهو جاهز للمعالجة من قِبل ضابط مراقبة الحدود.',
  'payment_status.desc.DYN.2.9': 'الطلب في انتظار الإشراف. قد يحتاج أحد المشرفين إلى مراجعة الطلب قبل أن تتم معالجته من قبل موظف مراقبة الحدود.',
  'payment_status.DYN.7': 'في انتظار التصحيح',
  'payment_status.DYN.8': 'في انتظار المراجعة والدفع لاحقاً',
  'payment_status.DYN.9': 'جاهز للدفع عند الوصول',
  'payment_status.DYN.9.entry': 'جاهز للتحقق',
  'payment_status.DYN.9.exit': 'جاهز لتسجيل المغادرة',
  'payment_status.DYN.2': 'تم تسجيل المغادرة',
  'payment_status.DYN.3': 'مكررة',
  'payment_status.DYN.4': 'مستردة',
  'payment_status.DYN.5': 'مرفوض',
  'payment_status.extension.DYN.5': 'تم رفض التمديد',
  'payment_status.DYN.5.blacklisted': 'مرفوض - مدرج في القائمة السوداء',
  'createPeople.success.DYN.': 'تم إنشاء الشخص بنجاح',
  'form.paymentType': 'نوع الدفع',
  'payment.type.online': 'عبر الإنترنت',
  'payment.type.offline': 'غير متصل بالإنترنت',
  'request.state.DYN.': 'حالة الطلب',
  'request.state.DYN.pass': 'حالة الطلب',
  'request.state.DYN.zwevisa': 'حالة الطلب',
  'form.birthDate': 'تاريخ الميلاد',
  'form.birthCountry': 'بلد الميلاد',
  'form.placeOfBirth': 'مدينة الميلاد',
  'form.residenceAdress': 'عنوان الإقامة',
  'form.maritalStatus': 'الحالة الاجتماعية',
  'form.departureDate': 'تاريخ المغادرة',
  'form.arrivalDate': 'تاريخ الوصول',
  'form.referencePreviousVisa': 'مرجع التأشيرة السابقة',
  'form.passportNumber': 'رقم جواز السفر',
  'form.hostName': 'اسم المضيف',
  'form.purposeOfVisit': 'الغرض من الزيارة',
  'form.previousConvictionsHome': 'الإدانات السابقة في البلد الأم',
  'form.spouse.birthDay': 'الزوج/الزوجة',
  'form.spousePassportNumber': 'الزوج/الزوجة',
  'form.spousePlaceOfBirth': 'الزوج/الزوجة',
  'form.dependantFullName': 'معتمد',
  'form.dependantPassportNumber': 'معتمد',
  'form.dependantPlaceOfBirth': 'معتمد',
  'form.dependantBirthDay': 'معتمد',
  'form.existingValidEntryReferenceOfficer': 'مسؤول مرجعي للدخول',
  'officer.unknown': 'ضابط غير معروف',
  'global.approve': 'الموافقة',
  'global.refuse': 'الرفض',
  'global.suspend': 'اطلب المراجعة',
  'personal.data': 'البيانات الشخصية',
  'contact.data': 'بيانات الاتصال',
  'divers.data.DYN.': 'تفاصيل السفر',
  'dependant.data': 'المعالون',
  'spouse.data': 'بيانات الزوج',
  'payment.review.approve.ask.DYN.': 'هل تريد حقًا مراجعة طلب هذا على أنه <b>موصى به</b>؟',
  'payment.review.refuse.ask.DYN.': 'هل تريد حقًا مراجعة طلب هذا على أنه <b>غير موصى به</b>؟',
  'payment.review.refuse.ask.extension.DYN.': 'هل تريد حقًا مراجعة طلب التمديد هذا على أنه <b>غير موصى به</b>؟',
  'payment.review.approve.extension.ask.DYN.': 'هل تريد حقًا الموافقة على طلب التمديد هذا؟',
  'payment.validate.ask.DYN.': 'هل تريد حقًا الموافقة على طلب هذا؟',
  'payment.validate.extension.ask.DYN.': 'هل تريد حقًا الموافقة على طلب التمديد هذا؟',
  'error.payment.suspend.error.DYN.': 'حدث خطأ أثناء تعليق طلب.',
  'global.no': 'لا',
  'err.ResidencePermitNumber.pattern': 'رقم تصريح الإقامة يجب أن يحتوي فقط على أحرف كبيرة وأرقام',
  'global.Yes': 'نعم',
  'global.No': 'لا',
  'dashboard.noPreviousApplication': 'لم يتم العثور على طلب سابق',
  'documents': 'المستندات',
  'data.biographic': 'صفحة السيرة الذاتية لجواز السفر',
  'residence.proof': 'إثبات الإقامة',
  'address.destination': 'عنوان الوجهة',
  'previous.visa': 'التأشيرة السابقة',
  'invite.letter': 'خطاب دعوة',
  'hostInvitation.letter': 'هوست',
  'proof.residenceHost': 'هوست',
  'hostResidential.status': 'هوست',
  'reasonOfVisit.proof': 'إثبات سبب الزيارة لبلد المقصد',
  'inviteBusiness.letter': 'إرسال الشركة ',
  'business.profile': 'المسافر ',
  'application.letter': 'خطاب طلب التأشيرة',
  'acceptanceFromScool.letter': 'خطاب التأكيد',
  'date.creation': 'تاريخ الإنشاء',
  'document.Passport': 'جواز السفر',
  'completeName': 'الاسم الكامل',
  'price': 'السعر',
  'global.retry': 'إعادة المحاولة',
  'err.loginWeak': 'مشكلة في الاتصال، يرجى المحاولة مرة أخرى',
  'URGENTPASS.title': 'جواز السفر العاجل',
  'refusalReason': 'سبب الرفض',
  'error.payment.noRefuseReason': 'الرجاء إدخال رسالة',
  'error.payment.noSuspendReason': 'يرجى إدخال سبب التعليق. سيتم إرسال هذا السبب إلى العميل.',
  'refusal.desc.DYN.': 'تم رفض طلب هذا.',
  'refusal.desc.extension.DYN.': 'تم رفض طلب التمديد هذا.',
  'approval.desc.DYN.': 'تمت الموافقة على طلب هذا.',
  'approval.desc.extension.DYN.': 'تمت الموافقة على طلب التمديد هذا.',
  'review.approval.desc.DYN.': 'يفي طلب هذا بالمتطلبات.',
  'review.approval.desc.extension.DYN.': 'يستوفي طلب التمديد هذا المتطلبات.',
  'review.refusal.desc.DYN.': 'لا يفي طلب هذا بالمتطلبات.',
  'review.refusal.desc.extension.DYN.': 'طلب التمديد هذا لا يفي بالمتطلبات.',
  'err.getUsers: client.extended.notActiveToken': 'انتهت صلاحية جلسة العمل الخاصة بك. يرجى تسجيل الدخول مرة أخرى.',
  'VISA_DOUBLE.title': 'تأشيرة دخول مزدوجة',
  'VISA_KAZA.title': 'فيزا كازا',
  'history': 'التاريخ',
  'menu.people.DYN.': 'الأشخاص الذين تم إنقاذهم',
  'DYN.XBA': 'ألبانيا',
  'DYN.AGO': 'أنغولا',
  'DYN.ABW': 'أروبا',
  'DYN.ATG': 'أنتيغوا وباربودا',
  'DYN.BHS': 'جزر البهاما',
  'DYN.BRB': 'بربادوس',
  'DYN.BLZ': 'بليز',
  'DYN.BWA': 'بوتسوانا',
  'DYN.CYM': 'جزر كايمان',
  'DYN.CYP': 'قبرص',
  'DYN.FJI': 'فيجي',
  'DYN.COD': 'جمهورية الكونغو الديمقراطية',
  'DYN.GHA': 'غانا',
  'DYN.GRD': 'غرينادا',
  'DYN.HKG': 'منطقة هونغ كونغ الإدارية الخاصة (الصين)',
  'DYN.KEN': 'كينيا',
  'DYN.KIR': 'كيريباتي',
  'DYN.JAM': 'جامايكا',
  'DYN.LDW': 'جزر ليوارد',
  'DYN.LSO': 'ليسوتو',
  'DYN.MDG': 'مدغشقر',
  'DYN.MWI': 'ملاوي',
  'DYN.MYS': 'ماليزيا',
  'DYN.MDV': 'جزر المالديف',
  'DYN.MLT': 'مالطا',
  'DYN.MUS': 'موريشيوس',
  'DYN.MSR': 'مونتسيرات',
  'DYN.MOZ': 'موزمبيق',
  'DYN.NAM': 'ناميبيا',
  'DYN.NRU': 'ناورو',
  'DYN.LCA': 'سانت لوسيا',
  'DYN.VCT': 'سانت فنسنت وجزر غرينادين',
  'DYN.WSM': 'ساموا الغربية',
  'DYN.SYC': 'سيشيل',
  'DYN.SGP': 'سنغافورة',
  'DYN.SLB': 'جزر سليمان',
  'DYN.ZAF': 'جنوب أفريقيا',
  'DYN.KNA': 'سانت كيتس ونيفيس',
  'DYN.SWZ': 'سوازيلاند',
  'DYN.TON': 'تونغا',
  'DYN.TTO': 'ترينيداد وتوباغو',
  'DYN.TCA': 'جزر تركس وكايكوس',
  'DYN.TUV': 'توفالو',
  'DYN.UGA': 'أوغندا',
  'DYN.TZA': 'جمهورية تنزانيا المتحدة',
  'DYN.VUT': 'فانواتو',
  'DYN.VAT': 'الفاتيكان',
  'DYN.VEN': 'فنزويلا (جمهورية فنزويلا البوليفارية)',
  'DYN.USA': 'الولايات المتحدة الأمريكية',
  'DYN.URY': 'أوروغواي',
  'DYN.UZB': 'أوزبكستان',
  'DYN.UKR': 'أوكرانيا',
  'DYN.ARE': 'الإمارات العربية المتحدة',
  'DYN.GBR': 'المملكة المتحدة لبريطانيا العظمى وأيرلندا الشمالية',
  'DYN.TUR': 'تركيا',
  'DYN.TKM': 'تركمانستان',
  'DYN.SWE': 'السويد',
  'DYN.CHE': 'سويسرا',
  'DYN.TJK': 'طاجيكستان',
  'DYN.KAZ': 'كازاخستان',
  'DYN.SUR': 'سورينام',
  'DYN.ESP': 'اسبانيا',
  'DYN.SVK': 'سلوفاكيا',
  'DYN.SVN': 'سلوفينيا',
  'DYN.SEN': 'السنغال',
  'DYN.SRB': 'صربيا',
  'DYN.SMR': 'سان مارينو',
  'DYN.STP': 'ساو تومي وبرينسيبي',
  'DYN.NLD': 'هولندا',
  'DYN.NCL': 'كاليدونيا الجديدة',
  'DYN.NZL': 'نيوزيلندا',
  'DYN.NIC': 'نيكاراغوا',
  'DYN.MEX': 'المكسيك',
  'DYN.FSM': 'ميكرونيزيا، ولايات ميكرونيزيا الموحدة',
  'DYN.MDA': 'مولدوفا',
  'DYN.MCO': 'موناكو',
  'DYN.MHL': 'جزر مارشال',
  'DYN.LVA': 'لاتفيا',
  'DYN.NFK': 'جزيرة نورفولك',
  'DYN.MNP': 'جزر ماريانا الشمالية',
  'DYN.NOR': 'النرويج',
  'DYN.PLW': 'بالاو',
  'DYN.PSE': 'فلسطين',
  'DYN.PAN': 'بنما',
  'DYN.PNG': 'بابوا غينيا الجديدة',
  'DYN.PRY': 'باراغواي',
  'DYN.PER': 'بيرو',
  'DYN.POL': 'بولندا',
  'DYN.PRT': 'البرتغال',
  'DYN.PRI': 'بورتوريكو',
  'DYN.REU': 'الاجتماع',
  'DYN.ROU': 'رومانيا',
  'DYN.RUS': 'الاتحاد الروسي',
  'DYN.RWA': 'رواندا',
  'DYN.LIE': 'ليختنشتاين',
  'DYN.LTU': 'ليتوانيا',
  'DYN.LUX': 'لوكسمبورغ',
  'DYN.MAC': 'منطقة ماكاو الإدارية الخاصة (الصين)',
  'DYN.JPN': 'اليابان',
  'DYN.KWT': 'الكويت',
  'DYN.KGZ': 'قيرغيزستان',
  'DYN.KOR': 'كوريا الجنوبية',
  'DYN.GUY': 'غيانا',
  'DYN.HTI': 'هايتي',
  'DYN.HND': 'هندوراس',
  'DYN.IRL': 'أيرلندا',
  'DYN.ISR': 'إسرائيل',
  'DYN.ITA': 'ايطاليا',
  'DYN.HUN': 'هنغاريا',
  'DYN.ISL': 'أيسلندا',
  'DYN.IND': 'الهند',
  'DYN.IDN': 'إندونيسيا',
  'DYN.IRN': 'إيران',
  'DYN.GUM': 'غوام',
  'DYN.GTM': 'غواتيمالا',
  'DYN.GIB': 'جبل طارق',
  'DYN.GRC': 'اليونان',
  'DYN.GEO': 'جورجيا',
  'DYN.DEU': 'ألمانيا',
  'DYN.DNK': 'الدنمارك',
  'DYN.EST': 'إستونيا',
  'DYN.ETH': 'إثيوبيا',
  'DYN.FIN': 'فنلندا',
  'DYN.FRA': 'فرنسا',
  'DYN.GUF': 'غيانا الفرنسية',
  'DYN.PYF': 'بولينيزيا الفرنسية',
  'DYN.ATF': 'الأقاليم الجنوبية الفرنسية',
  'DYN.CZE': 'الجمهورية التشيكية',
  'DYN.COM': 'جزر القمر',
  'DYN.DOM': 'جمهورية الدومينيكان',
  'DYN.ECU': 'الإكوادور',
  'DYN.EGY': 'مصر',
  'DYN.SLV': 'السلفادور',
  'DYN.GNQ': 'غينيا الاستوائية',
  'DYN.CHL': 'شيلي',
  'DYN.CHN': 'الصين',
  'DYN.CHN_NT': 'الصين (غير سياحية)',
  'DYN.COK': 'جزر كوك',
  'DYN.CRI': 'كوستاريكا',
  'DYN.HRV': 'كرواتيا',
  'DYN.CUB': 'كوبا',
  'DYN.BDI': 'بوروندي',
  'DYN.CAN': 'كندا',
  'DYN.CPV': 'الرأس الأخضر',
  'DYN.BRA': 'البرازيل',
  'DYN.VGB': 'جزر فيرجن البريطانية',
  'DYN.BRN': 'بروناي دار السلام',
  'DYN.BGR': 'بلغاريا',
  'DYN.BMU': 'برمودا',
  'DYN.BTN': 'بوتان',
  'DYN.BIH': 'البوسنة والهرسك',
  'DYN.BLR': 'بيلاروسيا',
  'DYN.BEL': 'بلجيكا',
  'DYN.BHR': 'البحرين',
  'DYN.ARG': 'الأرجنتين',
  'DYN.ARM': 'أرمينيا',
  'DYN.AUS': 'استراليا',
  'DYN.AUT': 'النمسا',
  'DYN.AZE': 'أذربيجان',
  'DYN.ALB': 'ألبانيا',
  'DYN.DZA': 'الجزائر',
  'DYN.AIA': 'أنغيلا',
  'DYN.BGD': 'بنغلاديش',
  'DYN.BEN': 'بنين',
  'DYN.AFG': 'أفغانستان',
  'DYN.BOL': 'بوليفيا',
  'DYN.BFA': 'بوركينا فاسو',
  'DYN.KHM': 'كمبوديا',
  'DYN.CMR': 'الكاميرون',
  'DYN.CAF': 'جمهورية أفريقيا الوسطى',
  'DYN.TCD': 'تشاد',
  'DYN.COL': 'كولومبيا',
  'DYN.ERI': 'إريتريا',
  'DYN.COG': 'الكونغو برازافيل',
  'DYN.PRK': 'الشعب الديمقراطي ',
  'DYN.GAB': 'الغابون',
  'DYN.GMB': 'غامبيا',
  'DYN.DJI': 'جيبوتي',
  'DYN.GIN': 'غينيا - كوناكري',
  'DYN.GNB': 'غينيا بيساو',
  'DYN.IRQ': 'العراق',
  'DYN.KOS': 'كوسوفو',
  'DYN.LAO': 'لاو بيبول ',
  'DYN.JOR': 'الأردن',
  'DYN.LBR': 'ليبيريا',
  'DYN.LBY': 'الجماهيرية العربية الليبية',
  'DYN.MLI': 'مالي',
  'DYN.QAT': 'قطر',
  'DYN.REF': 'لاجئ',
  'DYN.PHL': 'الفلبين',
  'DYN.OMN': 'سلطنة عمان',
  'DYN.PAK': 'باكستان',
  'DYN.LBN': 'لبنان',
  'DYN.MRT': 'موريتانيا',
  'DYN.MNG': 'منغوليا',
  'DYN.MNE': 'مونتينيغرو',
  'DYN.NER': 'النيجر',
  'DYN.NGA': 'نيجيريا',
  'DYN.MMR': 'ميانمار',
  'DYN.MAR': 'المغرب',
  'DYN.NPL': 'نيبال',
  'DYN.SAU': 'المملكة العربية السعودية',
  'DYN.SLE': 'سيراليون',
  'DYN.SOM': 'الصومال',
  'DYN.LKA': 'سريلانكا',
  'DYN.SSD': 'جنوب السودان',
  'DYN.SDN': 'السودان',
  'DYN.THA': 'تايلاند',
  'DYN.MKD': 'جمهورية مقدونيا اليوغوسلافية السابقة',
  'DYN.TGO': 'توغو',
  'DYN.SYR': 'الجمهورية العربية السورية',
  'DYN.TWN': 'تايوان',
  'DYN.TUN': 'تونس',
  'DYN.VNM': 'فيتنام',
  'DYN.YEM': 'اليمن',
  'DYN.TLS': 'تيمور الشرقية',
  'DYN.AND': 'أندورا',
  'DYN.VIR': 'جزر فيرجن (الولايات المتحدة)',
  'DYN.XKX': 'كوسوفو',
  'DYN.ZWE': 'زيمبابوي',
  'DYN.ZMB': 'زامبيا',
  'DYN.ASM': 'ساموا الأمريكية',
  'DYN.DMA': 'دومينيكا',
  'DYN.XXA': 'عديم الجنسية',
  'DYN.XXB': 'لاجئ (اتفاقية جنيف)',
  'DYN.XXC': 'لاجئ (أخرى)',
  'DYN.UNA': 'وكالة الأمم المتحدة',
  'DYN.UNO': 'منظمة الأمم المتحدة',
  'DYN.role.0': 'العميل',
  'DYN.role.1': 'موظف',
  'DYN.role.2': 'أوربيس المستهلك',
  'DYN.role.3': 'المدير',
  'DYN.role.4': 'أمين سجل الشركاء',
  'DYN.role.5': 'كشك',
  'DYN.role.6': 'المراقب الخارجي',
  'err.Occupation.pattern': 'يجب أن يكون للوظيفة تنسيق صحيح',
  'err.PreviousConvictionsHome.pattern': 'يجب أن يكون شكل الإدانات السابقة في البلد الأصلي صحيحًا',
  'err.PlaceOfBirth.pattern': 'يجب أن يكون مكان الميلاد بصيغة صحيحة',
  'document.type.DYN.': 'نوع التطبيق',
  'form.spouseFullName': 'الزوج/الزوجة',
  'qrDesc.valid': 'قم بإبراز رمز الاستجابة السريعة هذا عند نقطة تفتيش التأشيرة عند دخول/مغادرة البلد. لا يمكنك السفر بدون رمز الاستجابة السريعة ساري المفعول أولاً.',
  'err.pay': 'حدث خطأ أثناء الدفع. حاول مرة أخرى.',
  'payment.noEvents': 'لا يتضمن هذا التطبيق حالياً أي معالجة متعلقة بالسفر (استخدامات التطبيق).',
  'global.cancel': 'إلغاء',
  'global.loading': 'جارِ التحميل',
  'end.suspend': 'إنهاء المراجعة',
  'trips.title': 'تتبع التطبيقات',
  'trips.desc': 'التطبيق (التطبيقات)',
  'BatchId': 'مرجع التطبيق',
  'newBatchId.desc': 'يُرجى إدخال اسم لهذا السفر.',
  'personLinkType.DYN.0': 'غير معروف',
  'personLinkType.DYN.1': 'الطفل',
  'personLinkType.DYN.2': 'الوالدين',
  'personLinkType.DYN.3': 'الزوج',
  'personLinkType.DYN.4': 'أخرى',
  'personLinkType.DYN.5': 'ذاتي',
  'trip.name': 'مرجع التطبيق',
  'visaIntro.validFrom': 'تاريخ البدء',
  'visaIntro.validUntil': 'تاريخ انتهاء الصلاحية',
  'visaIntro.usageCount': 'الاستخدام (الاستخدامات) المسموح بها',
  'client.extended.passportNumberAlreadyExists': 'رقم جواز السفر هذا مستخدم بالفعل. يرجى إدخال رقم آخر.',
  'client.extended.alreadyDecided': 'لقد تمت مراجعة طلب التأشيرة هذا بالفعل من قبلك. لا يمكنك مراجعته مرة أخرى.',
  'client.extended.outOfUsage': 'هذا الطلب <b> خارج فترة صلاحيته</b>',
  'global.review': 'المراجعة',
  'error.review.noChoice': 'يرجى تحديد حالة المراجعة من أجل المتابعة.',
  'all.reviews': 'جميع مراجعات طلب التأشيرة هذا',
  'all.reviews.extension': 'جميع مراجعات طلب التمديد هذا',
  'approve.text': 'تمت الموافقة على هذا الطلب.',
  'global.reason': 'السبب',
  'pending.desc': 'طلب التأشيرة هذا ينتظر حالياً التصحيح من العميل.',
  'successRequest.title': 'تم تقديم الطلب بنجاح',
  'amountDue': 'السعر:',
  'amountDue.total.now': 'المجموع المستحق الآن',
  'amountDue.total.later': 'المجموع المستحق في مكتب الضابط:',
  'noPrint.mobile': 'طباعة الصفحات غير مدعومة على الأجهزة المحمولة',
  'onArrival.reset': 'بدء عملية جديدة',
  'onArrival.reset.ask': 'هل تريد حقاً أن تبدأ عملية جديدة؟',
  'stillHere': 'هل ما زلت هناك؟ ستتم إعادة ضبط هذه العملية نفسها خلال 20 ثانية.',
  'print.request': 'اطبع الطلب',
  'EXPIRED.globalExplain': 'تم رفض هذا الطلب. فهو لا يتوافق مع معاييرنا.',
  'payment_status.desc.DYN.7': 'طلب هذا في انتظار التصحيح من العميل.',
  'payment_status.DYN.6.review': 'في انتظار المراجعة - {مراجعةالعدد} / 2',
  'payment_status.extension.DYN.6': 'في انتظار المراجعة',
  'payment_status.extension.DYN.6.review': 'في انتظار المراجعة - {مراجعةالعدد}/1',
  'payment_status.DYN.8.review': 'في انتظار المراجعة',
  'payment_status.desc.DYN.6.review': 'طلب هذا في انتظار المراجعة حاليًا. تمت مراجعته بالفعل {reviewCount} مرة (مرات) المراجعة.',
  'payment_status.desc.DYN.8.review': 'طلب هذا ينتظر حالياً مراجعة المشرف عليه.',
  'payment_status.DYN.6.finalReview': 'في انتظار المراجعة النهائية',
  'payment_status.extension.DYN.6.finalReview': 'في انتظار المراجعة النهائية',
  'payment_status.desc.DYN.6.finalReview': 'تمت مراجعة طلب هذا وهو حالياً في انتظار المراجعة النهائية.',
  'payment_status.desc.DYN.0': 'هذا الطلب حالياً في انتظار التحقق من صحة الدفع في مؤسسة الدفع. إذا لم يتم الدفع بعد، فيمكن إتمامه الآن.',
  'payment_status.desc.DYN.5': 'تم رفض طلب هذا.',
  'payment_status.desc.DYN.5.blacklisted': 'تم رفض طلب هذا وتم إدراج الشخص على القائمة السوداء.',
  'payment_status.desc.DYN.5.checkIn': 'تم رفض هذا الطلب أثناء تسجيل الوصول إلى الضابط ',
  'payment_status.desc.DYN.5.checkIn.reason': 'تم رفض هذا الطلب أثناء تسجيل الوصول إلى الضابط ',
  'payment_status.DYN.5.checkIn': 'الرفض عند تسجيل الوصول',
  'payment_status.desc.DYN.5.checkOut': 'تم رفض هذا الطلب أثناء تسجيل المغادرة لدى الضابط ',
  'payment_status.DYN.5.checkOut': 'مرفوض عند تسجيل المغادرة',
  'payment_status.desc.DYN.9': 'يكون طلب جاهزاً للدفع في مكتب الموظف. يمكن إكمال تسجيل الوصول بعد الدفع.',
  'payment_status.desc.DYN.9.entry': 'هذا الطلب جاهز لتسجيل الوصول إلى مكتب الضابط.',
  'payment_status.desc.DYN.9.exit': 'هذا الطلب جاهز للمغادرة ويتطلب دفع ثمن تصريح المرور الحدودي الصادر من الضابط ',
  'payment_status.DYN.2.out': 'جاهز لتسجيل المغادرة',
  'payment_status.DYN.2.outFinish': 'تم تسجيل المغادرة',
  'payment_status.DYN.2.closed': 'مغلق',
  'payment_status.desc.DYN.2.closed': 'تم إغلاق هذا الطلب.',
  'payment_status.desc.DYN.2.zweexit': 'هذا الطلب جاهز للمغادرة في مكتب الضابط.',
  'payment_status.DYN.2.entryFinish': 'تم تسجيل الوصول',
  'payment_status.DYN.2.in': 'جاهز لتسجيل الوصول',
  'payment_status.desc.DYN.2.out': 'تم تسجيل هذا الطلب. الخطوة التالية هي تسجيل المغادرة في مكتب الضابط.',
  'payment_status.desc.DYN.2.outFinish': 'تم التحقق من هذا الطلب. يمكن للعميل الآن السفر.',
  'payment_status.desc.DYN.2.entryFinish': 'تم تسجيل دخول هذا الطلب. يمكن للعميل الآن الدخول إلى البلد.',
  'payment_status.desc.DYN.2.in': 'ينتظر هذا الطلب تسجيل الدخول في مكتب الضابط.',
  'ask.isArrivalPaid': 'يجب دفع المبلغ التالي الآن بأي من العملات التالية:',
  'ask.isArrivalPaid.exit': 'يجب دفع قيمة بطاقة الحدود الآن بأي من العملات التالية:',
  'ask.isExtension.confirm': 'هل تؤكد أن عملية الدفع قد تمت؟ إذا أكدت ذلك، يرجى إدخال مرجع الدفع وطريقة الدفع والعملة المستخدمة.',
  'ask.isArrivalPaid.confirm.exit': 'هل تؤكد أن عملية الدفع قد تمت؟ إذا أكدت ذلك، يرجى إدخال مرجع الدفع والعملة المستخدمة.',
  'ask.checkoutExpired.confirm': 'هل تؤكد أن عملية الدفع قد تمت؟ إذا أكدت ذلك، يرجى إدخال مرجع الدفع والعملة المستخدمة.',
  'no_trips': 'أنت دون ',
  'err.canActivate': 'حدث خطأ',
  'form.passportNumber.dateOfIssue': 'تاريخ إصدار جواز السفر',
  'form.passportNumber.dateOfExpiry': 'تاريخ انتهاء صلاحية جواز السفر',
  'form.passportNumber.placeOfIssue': 'مكان إصدار جواز السفر',
  'nextOfKin.data': 'جهة اتصال الطوارئ / أقرب الأقارب',
  'form.otherLinkType': 'تحديد نوع رابط العلاقة',
  'camera.problem.manual': 'أنت على وشك تسجيل الدخول/الخروج من طلب التأشيرة هذا بدون صورة للعميل. هل أنت متأكد من رغبتك في المتابعة؟',
  'camera.problem.button': 'هل هناك مشكلة في الكاميرا؟',
  'global.noFilter': '--لا يوجد مرشح---',
  'zweentry': 'الدخول بدون تأشيرة',
  'zweentry.title': 'الدخول بدون تأشيرة',
  'free.charge': 'مجاناً',
  'camera.init.error': 'حدث خطأ أثناء تهيئة الكاميرا. هل تريد تسجيل الدخول/الخروج من هذا التطبيق بدون صورة للعميل؟',
  'error.payment.noPaymentReference': 'يُرجى إدخال مرجع الدفع وطريقة الدفع والعملة المستخدمة.',
  'paymentReference.ask': 'مرجع الدفع',
  'paymentReference.askExpired': 'مرجع الدفع مقابل رسوم الإقامة الزائدة',
  'session.expired': 'انتهت صلاحية جلسة العمل الخاصة بك. يرجى تسجيل الدخول مرة أخرى.',
  'phone.pattern': ' (أي: +263771234567)',
  'ask.place.updatePermissions': 'هل أنت متأكد من أنك تريد تحديث صلاحيات هذا المكان؟',
  'place.updatePermissions.success': 'تم تحديث أذونات المكان بنجاح.',
  'err.place.updatePermissions': 'حدث خطأ أثناء تحديث أذونات المكان.',
  'global.urgent': 'عاجل',
  'form.usageAfter': 'صالح من',
  'form.usageUntil': 'صالحة حتى',
  'form.localUsageUntil': 'الحد الأقصى لتاريخ انتهاء الإقامة',
  'form.timeslot': 'فترات زمنية',
  'internalReference': 'مرجع المقر الرئيسي',
  'payment_status.DYN.6.0': 'في انتظار المراجعة 0/2',
  'payment_status.DYN.6.1': 'في انتظار المراجعة 1/2',
  'payment_status.DYN.6.2': 'في انتظار المراجعة النهائية',
  'payment_status.DYN.8.0': 'في انتظار مراجعة الهبوط',
  'payment_status.DYN.2.0': 'تم تسجيل الوصول',
  'payment_status.DYN.2.4': 'جاهز لتسجيل المغادرة',
  'payment_status.DYN.2.5': 'تم تسجيل المغادرة',
  'payment_status.DYN.2.6': 'الرفض عند تسجيل الوصول',
  'payment_status.DYN.2.7': 'مرفوض عند تسجيل المغادرة',
  'payment_status.DYN.2.8': 'مغلق',
  'payment_status.extension.DYN.6.0': 'في انتظار المراجعة 0/1',
  'payment_status.extension.DYN.6.2': 'في انتظار المراجعة النهائية',
  'payment_status.extension.DYN.7': 'في انتظار التصحيح',
  'payment_status.extension.DYN.9': 'تم التحقق من صحة التمديد',
  'payment_status.extension.DYN.0': 'في انتظار السداد',
  'internalReference.create': 'إضافة مرجع للمقر الرئيسي',
  'internalReference.edit': 'تحرير مرجع المقر الرئيسي',
  'timeslot.set': 'تحديد موعد',
  'timeslot.setNew': 'تحديد موعد جديد',
  'internalReference.ask.edit': 'يُرجى إدخال مرجع المقر الرئيسي الجديد.',
  'internalReference.ask.create': 'يُرجى إدخال مرجع المقر الرئيسي.',
  'internalReference.done.create': 'تمت إضافة مرجع المقر الرئيسي بنجاح.',
  'internalReference.done.edit': 'تم تحرير مرجع المقر الرئيسي بنجاح.',
  'error.internalReference': 'حدث خطأ أثناء إضافة/تعديل مرجع المقر الرئيسي.',
  'error.paymentUntil.expired': 'تجاوز هذا الطلب فترة صلاحيته. يمكنك متابعة عملية الدفع للعميل؛ ومع ذلك، يرجى العلم أنه يجب دفع رسوم قدرها 100 دولار أمريكي بسبب انتهاء صلاحية طلب التأشيرة. يجب أن يتم الدفع فوراً بأي من العملات التالية:',
  'internalReference.desc': 'أضف مرجع HQ لهذا التطبيق (على سبيل المثال، 140_2024).',
  'globalStatus.valid': 'سارية المفعول',
  'PENDING.globalExplain': 'هذا الطلب في انتظار التصحيح. يرجى التحقق من المعلومات وتصحيحها.',
  'PAID_NOT_CONFIRMED.globalExplain': 'هذا الطلب في انتظار تأكيده من قبل خدماتنا.',
  'PROPOSED.globalExplain': 'هذا الطلب في انتظار الدفع. إذا لم تكن قد قمت بالتحقق من صحة الدفع بعد، يمكنك القيام بذلك الآن.',
  'photo.current': 'الصورة الحالية',
  'photo.scanned': 'صورة ممسوحة ضوئياً من جواز السفر',
  'createdAt': 'تاريخ الإنشاء',
  'all.infos': 'معلومات حول هذا التطبيق',
  'afterRefused': 'تواريخ السفر المعلنة : {التاريخ بعد}.',
  'DYN.paymentError.desc.success': `<p>تم تسجيل طلبك بنجاح. إذا كان أي جزء من هذا الطلب يتطلب موافقة من فرقنا، فسيتم إخطارك بمجرد اكتمال هذه العملية. وإلا، يرجى العلم بأننا قد استلمنا طلبك.</p>
  <p><b>شكرًا لاختيارك خدماتنا.</b></p>`,
  'sinceOneWeek': 'يرجى ملاحظة أن هذا المستند في حالة انتظار المراجعة منذ أكثر من أسبوع.',
  'client.extended.onlyAdminDecide': 'لقد تمت مراجعة طلب التأشيرة هذا بالفعل من قبل عامل له نفس أقدميتك. لا يمكنك مراجعته مرة أخرى.',
  'error.paymentUntil.before': 'التاريخ مبكر جداً. سيكون هذا الطلب صالحاً اعتباراً من {التاريخ بعد}.',
  'applicant.gender.FEMALE': 'أنثى',
  'applicant.gender.MALE': 'ذكر',
  'entry.consume': 'القادمون',
  'exit.consume': 'المغادرون',
  'scan.noConsumeMode': 'بصفتك ضابط حدود، فأنت مكلف بإدارة كل من عمليات الدخول والخروج. يُرجى تحديد الخيار المطابق لمهمتك الحالية: معالجة القادمين أو إدارة المغادرين.',
  'scan.noVisaFound': 'لم يتم العثور على أي سجل في حالة "جاهز لتسجيل المغادرة" لخروج هذا الشخص. هل ترغب في إنشاء سجل جاهز لتسجيل الخروج؟',
  'zweexit': 'الخروج بدون تأشيرة',
  'err.scanPassport': 'حدث خطأ أثناء مسح جواز السفر. يرجى التأكد من إدخاله بشكل صحيح والمحاولة مرة أخرى. إذا استمرت المشكلة، يرجى إعادة تشغيل التطبيق أو الاتصال بالدعم.',
  'exit.register': 'تسجيل خروج',
  'entry.register': 'تسجيل قيد',
  'exit.create': 'إنشاء مخرج بدون تأشيرة',
  'exit.ask': 'هل أنت متأكد من رغبتك في تسجيل خروج بدون تأشيرة لهذا الشخص؟',
  'border': 'ضابط على الحدود',
  'global.signout': 'تسجيل الخروج',
  'search.manually': 'تطبيق البحث',
  'scan.applicationQr': 'تطبيق المسح الضوئي QR',
  'err.client.extended.maxUsageCountReached': 'تم الوصول إلى الحد الأقصى لعدد مرات الاستخدام لهذا التطبيق.',
  'form.firstName.scanned': 'الاسم (الأسماء) الأولى الممسوحة ضوئياً',
  'form.lastName.scanned': 'اسم العائلة الممسوح ضوئياً',
  'form.gender.scanned': 'الجنس الممسوح ضوئياً',
  'form.birthDate.scanned': 'تاريخ الميلاد الممسوح ضوئياً',
  'form.nationality.scanned': 'الجنسية الممسوحة ضوئياً',
  'form.nationality': 'الجنسية',
  'scanned': 'تم المسح الضوئي',
  'DYN.document.P': 'جواز السفر',
  'DYN.document.ID': 'بطاقة الهوية',
  'DYN.document.D': 'سائق ',
  'DYN.document.IR': 'تصريح الإقامة',
  'DYN.document.OTHER': 'المستند',
  'application.data': 'بيانات التطبيق',
  'no.passportPhoto': 'لا توجد صورة',
  'overstay': 'الإقامة الزائدة',
  'method.payment': 'طريقة الدفع',
  'review.desc': 'الموافقة/الرفض',
  'approval.usageUntil.DYN.': 'تغيير تاريخ انتهاء الصلاحية (اختياري)',
  'scanned.list': 'قائمة التطبيقات التي تم العثور عليها',
  'scanned.recommended': 'موصى به',
  'scanned.entriesUsed': 'إدخالات مستخدمة',
  'scanned.paid': 'مدفوع',
  'visa.blacklist': 'تم إدراج طلب التأشيرة هذا في القائمة السوداء. ولا يُسمح للشخص بدخول البلد.',
  'scan.noEntryFound': 'لم يتم العثور على أي سجل في حالة "جاهز لتسجيل الدخول" لقيد لهذا الشخص. هل ترغب في إنشاء سجل جاهز لتسجيل الدخول؟',
  'global.syncing': 'مزامنة...',
  'payment.consume.error.DYN.': 'حدث خطأ أثناء معالجة الطلب.',
  'tooltip.changeTimeslot': 'تعديل الفترة الزمنية',
  'tooltip.transit': 'حدد هذا المربع لإدارة النقل كموظف حدود.',
  'tooltip.Qr': 'يمكنك مسح رمز الاستجابة السريعة المرتبط بتطبيق ما مباشرةً للعثور على معلومات مفصلة حول هذا التطبيق.',
  'tooltip.arrivals': 'حدد خانة الاختيار هذه لإدارة الوافدين كضابط حدود.',
  'tooltip.departures': 'حدد خانة الاختيار هذه لإدارة عمليات المغادرة كضابط حدود.',
  'tooltip.searchManually': 'ابحث عن تطبيق معين باستخدام معايير مختلفة.',
  'tooltip.signout': 'تسجيل الخروج من التطبيق.',
  'tooltip.my_account': 'الوصول إلى إعدادات حسابك.',
  'tooltip.dashboard': 'الوصول إلى لوحة التحكم.',
  'tooltip.createRequests': 'إنشاء تطبيق جديد.',
  'tooltip.trips': 'اعرض حالة طلباتك واطبع المستند المرتبط في حالة الموافقة عليه.',
  'tooltip.people': 'إدارة الأشخاص المرتبطين بحسابك.',
  'tooltip.users': 'إدارة مستخدمي التطبيق.',
  'tooltip.places': 'إدارة أماكن التطبيق.',
  'tooltip.role': 'دورك واسمك داخل التطبيق.',
  'tooltip.exitRegister': 'تسجيل خروج بدون تأشيرة يدوياً لشخص ما.',
  'tooltip.entryRegister': 'تسجيل دخول شخص يدوياً بدون تأشيرة دخول لشخص ما.',
  'tooltip.support': 'اتصل بالدعم للمساعدة في أي مشكلة.',
  'tooltip.chooseLang': 'تغيير لغة التطبيق. تتوفر حالياً اللغة الإنجليزية فقط.',
  'tooltip.changePassword': 'قم بتغيير كلمة المرور الخاصة بك.',
  'tooltip.internalReferenceNoFilter': 'انقر على مرجع داخلي، إذا كان متاحاً، لإعادة توجيهك إلى المرجع المرتبط.',
  'tooltip.state': 'تصفية الطلبات بناءً على حالتها.',
  'tooltip.tableBatchId': 'مرجع التطبيق المرتبط بالتطبيق',
  'tooltip.tableState': 'حالة الطلب',
  'tooltip.tableUsageAfter': 'تاريخ بدء تقديم الطلب',
  'tooltip.tableUsageUntil': 'تاريخ انتهاء صلاحية الطلب',
  'tooltip.history': 'سجل الدفع الخاص بطلباتك.',
  'tooltip.addPerson': 'إضافة شخص جديد مرتبط بحسابك.',
  'tooltip.urgent': 'هذا يعني أن الطلب تم وضع علامة "عاجل" عليه ويجب معالجته في أقرب وقت ممكن.',
  'tooltip.operationId': 'نوع التطبيق.',
  'tooltip.purposeOfVisit': 'الغرض من الزيارة لهذا الطلب.',
  'tooltip.amount': 'سعر هذا التطبيق.',
  'tooltip.paymentType': 'نوع الدفع مقابل طلب التأشيرة هذا.',
  'tooltip.paymentReference': 'مرجع الدفع مقابل طلب التأشيرة هذا.',
  'tooltip.review': 'راجع طلب التأشيرة هذا على أنه موافق عليه أو مرفوض وأضف تعليقاً.',
  'tooltip.revision': 'اطلب من العميل تصحيح طلب التأشيرة.',
  'tooltip.approve': 'الموافقة على طلب التأشيرة هذا كقرار نهائي. يمكنك أيضاً إضافة تعليق. إذا كان مصطلح "مدرج في القائمة السوداء"، فسيتم إدراج الشخص في القائمة السوداء.',
  'tooltip.refuse': 'رفض طلب التأشيرة هذا كقرار نهائي. يمكنك أيضاً إضافة تعليق.',
  'tooltip.qrSee': 'راجع رمز الاستجابة السريعة لهذا التطبيق واطبع المستند المرتبط به.',
  'tooltip.internalEdit': 'قم بتحرير المرجع الداخلي لطلب التأشيرة هذا.',
  'tooltip.internalAdd': 'إضافة مرجع داخلي لهذا التطبيق.',
  'tooltip.printApplication': 'اطبع الطلب مع جميع المعلومات.',
  'tooltip.allReviews': 'جميع المراجعات الخاصة بطلب التأشيرة هذا، مع التاريخ والمستخدم الذي قام بالمراجعة.',
  'tooltip.version': 'الإصدار الحالي من التطبيق.',
  'tooltip.consumeProfile.IN': 'الصورة التي تم التقاطها عند نقطة الدخول.',
  'tooltip.consumeNoProfile.IN': 'لم يتم التقاط أي صورة عند نقطة الدخول.',
  'tooltip.consumeTime.IN': 'تاريخ ووقت نقطة الدخول.',
  'tooltip.consumePlace.IN': 'مكان نقطة الدخول.',
  'tooltip.consumeProfile.OUT': 'الصورة التي تم التقاطها عند نقطة الخروج.',
  'tooltip.consumeNoProfile.OUT': 'لم يتم التقاط أي صورة عند نقطة الخروج.',
  'tooltip.consumeTime.OUT': 'تاريخ ووقت نقطة الخروج.',
  'tooltip.consumePlace.OUT': 'مكان نقطة الخروج.',
  'tooltip.consumeOfficer.OUT': 'الضابط الذي قام بفحص الشخص',
  'tooltip.consumeOfficer.IN': 'الضابط الذي قام بتسجيل دخول الشخص',
  'tooltip.passportComparison': 'المعلومات الممسوحة ضوئياً من جواز السفر. يسمح لك بمقارنة المعلومات مع المعلومات الفعلية للطلب.',
  'tooltip.classicComparison': 'المعلومات الفعلية للطلب. يسمح لك بمقارنة المعلومات مع المعلومات الممسوحة ضوئياً من جواز السفر.',
  'tooltip.trackingApplicationReference': 'مرجع تطبيق أطروحات الطلبات',
  'tooltip.allTrackingInfo': 'جميع المعلومات حول هذا التطبيق',
  'tooltip.trackingPrint': 'اطبع المستند المرتبط بهذا التطبيق',
  'tooltip.docFirstName': 'أدخل الاسم الأول للشخص كما يظهر في جواز السفر.',
  'tooltip.docLastName': 'أدخل الاسم الأخير للشخص كما يظهر في جواز السفر.',
  'tooltip.docPassportNumber': 'أدخل رقم جواز سفر الشخص.',
  'tooltip.docLinkType': 'حدد نوع العلاقة التي تربطك بالشخص.',
  'tooltip.docLinkTypeOther': 'حدد نوع العلاقة التي تربطك بالشخص بدقة.',
  'tooltip.applicationReferenceRequest': 'مرجع التطبيق الخاص بالطلب. وهو فريد لكل طلب، ويتم إنشاؤه تلقائياً.',
  'tooltip.portEntryRequest': 'ميناء دخول الطلب. وهو المكان الذي سيدخل منه الشخص إلى البلد.',
  'tooltip.otherName': 'أدخل الاسم الآخر لمقدم الطلب كما يظهر في جواز السفر.',
  'tooltip.spouseCheckbox': 'ضع علامة في هذه الخانة إذا كان لمقدم الطلب زوج، واملأ المعلومات أدناه.',
  'tooltip.hostName': 'اسم الشخص/المنظمة التي ستستضيف مقدم الطلب.',
  'tooltip.scanPassport': 'امسح جواز سفر مقدم الطلب ضوئيًا للعثور على الطلب المرتبط بجواز السفر هذا. إذا لم يتم العثور على أي طلب، يمكنك إنشاء طلب جديد.',
  'tooltip.passportScanned': 'المعلومات الممسوحة ضوئياً من جواز السفر.',
  'tooltip.scannedCard': 'تم العثور على تطبيقات مماثلة مع المعلومات الممسوحة ضوئياً.',
  'scan.error': 'حدث خطأ أثناء مسح المستند ضوئياً.',
  'tooltip.webcamProblems': 'إذا كانت الكاميرا لا ',
  'tooltip.checkOut': 'تحقق من شخص البلد.',
  'tooltip.checkIn': 'تسجيل دخول الشخص في البلد.',
  'tooltip.consumeRefuse': 'رفض دخول الشخص أو خروجه.',
  'tooltip.finalRefuse': 'القرار النهائي للطلب. لن يتمكن الشخص من دخول البلاد.',
  'tooltip.finalApprove': 'القرار النهائي للطلب. سيتمكن الشخص من دخول البلاد أو مغادرتها.',
  'tooltip.finalPending': 'القرار النهائي للطلب. لن يتمكن الشخص من دخول البلاد حتى يتم تصحيح الطلب والموافقة عليه.',
  'tooltip.finalRefuseBlacklist': 'القرار النهائي للطلب. لن يتمكن الشخص من دخول البلاد ويتم إدراجه في القائمة السوداء.',
  'photo.entryCountry.IN': 'صورة عند تسجيل الوصول',
  'photo.entryCountry.OUT': 'صورة عند تسجيل المغادرة',
  'err.noPassiveAuthenticationCSCA': 'الوثيقة صحيحة، ولكن تعذّر التحقق من صحة المستند من الجهة التي أصدرته.',
  'err.passport.expired': 'انتهت صلاحية جواز السفر.',
  'externalIndexedData': 'تم العثور على جوازات سفر متعددة',
  'client.extended.chargedBack': 'تم استرداد رسوم طلب التأشيرة هذا. ولا يزال بإمكان الفرد المضي قدماً في عملية السداد، ولكن يتعين عليه سداد رسوم الدخول نقداً فقط.',
  'ask.chargedBack.confirm': 'هل تؤكد أن الشخص قد سدد رسوم الدخول؟ إذا أكدت ذلك، يرجى إدخال مرجع السداد والعملة المستخدمة.',
  'error.payment.noReferenceChargedBack': 'يُرجى إدخال مرجع الدفع والعملة المستخدمة.',
  'client.extended.entryChargedBack': 'تم إعادة فرض رسوم على طلب التأشيرة هذا. لا يمكن للفرد متابعة تسجيل الدخول ويجب عليه إنشاء قيد جديد.',
  'tooltip.syncing': 'عدد عمليات التطبيق التي تخضع حالياً للمزامنة.',
  'adChoice': 'الاتصال بالدليل النشط',
  'external.down': 'الخدمة التي يعتمد عليها تطبيقنا لا تعمل حالياً. يرجى المحاولة مرة أخرى لاحقاً.',
  'global.connection.server': 'الخدمة غير متوفرة. نأسف على الإزعاج، يرجى إعادة المحاولة لاحقاً.',
  'global.connection.timeout': 'انتهت مهلة تحميل طلبك. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.',
  'global.connection.problem': 'خطأ في تحميل طلبك. يرجى التحقق من أنك لا تستخدم الشبكات الافتراضية الخاصة وجدران الحماية، وأن اتصالك بالإنترنت مستقر وحاول مرة أخرى.',
  'err.passport.issuedSoon': 'تم إصدار جواز السفر مؤخرًا (قبل أقل من شهر).',
  'global.reload': 'إعادة التحميل',
  'error.passportScan': 'CertBytes (b64): <pre>{certBytes}</pre>',
  'glpi.err.noPassiveAuthenticationCSCA': 'جواز السفر/جواز السفر',
  'glpi.err.unverifiedDoc': 'فشل في استرداد وحدات بايت الشهادة للمصادقة السلبية؛ وينتج عن ذلك حدوث ',
  'glpi.err.noPassiveAuthentication': 'فشل في إجراء المصادقة السلبية؛ ينتج عن ذلك حدوث',
  'glpi.err.noConnect': 'فشل في إنشاء اتصال مع شريحة جواز السفر، مما أدى إلى حدوث ',
  'glpi.err.noBAC': 'لم تتمكن شركة BAC من إثبات ذلك باستخدام معلومات منطقة الرنين المغناطيسي المقدمة، مما أدى إلى حدوث',
  'glpi.err.alteredDoc': 'تجزئات مجموعة البيانات (DGS) غير صحيحة لمدخل واحد أو أكثر، مما يؤدي إلى حدوث ',
  'glpi.err.revokedDocSigner': 'وثيقة التوقيع',
  'match.type': 'نوع المطابقة',
  'match.hair': 'الشعر',
  'match.eyes': 'العيون',
  'match.height': 'الارتفاع',
  'match.weight': 'الوزن',
  'match.race': 'العرق',
  'global.category': 'الفئة',
  'watchlist.alertLevel': 'مستوى تنبيه قائمة المراقبة',
  'global.score': 'النتيجة',
  'watchlist.name': 'اسم قائمة المراقبة',
  'watchlist.marks': 'العلامات',
  'tooltip.watchlist': 'معلومات قائمة المراقبة التي تم العثور عليها لهذا الشخص',
  'watchList.category': 'فئة قائمة المراقبة',
  'watchlist.level': 'مستوى التنبيه',
  'scan.fingerprint.desc': 'عندما تكون جاهزاً، انقر على الزر أدناه لبدء عملية أخذ بصمة الشخص. يجب على الشخص وضع إصبع السبابة على الماسح الضوئي عندما يضيء الضوء الأحمر لجهاز البصمة كما يشير الضابط.',
  'scan.fingerprint.noResponse': 'لا توجد استجابة من الماسح الضوئي لبصمات الأصابع. هل وضع الشخص إصبعه على الماسح الضوئي؟ هل الجهاز متصل بشكل صحيح؟',
  'scan.fingerprint': 'بصمة الإصبع',
  'fingerprint.scan.start': 'مسح بصمة الإصبع',
  'fingerprint.notAvailable': 'يبدو أن الماسح الضوئي لبصمات الأصابع غير متوفر، أو أن برامج التشغيل غير مثبتة. لا يزال بإمكانك متابعة تسجيل الوصول بدون بصمات الأصابع.',
  'skip': 'تخطي',
  'global.checkOut.fingerprint': 'تسجيل المغادرة ببصمة الإصبع',
  'global.checkIn.fingerprint': 'تسجيل الدخول ببصمة الإصبع',
  'tooltip.checkOut.fingerprint': 'تحقق من شخص البلد صاحب البصمة.',
  'tooltip.checkIn.fingerprint': 'تسجيل دخول الشخص في البلد بالبصمة.',
  'paymentError.title': 'مشكلة في طلبك',
  'DYN.paymentError.desc.fail': 'للأسف، فشلت عملية الدفع. يرجى المحاولة مرة أخرى.',
  'DYN.paymentError.desc.error': 'لسوء الحظ، لقد أعادت معالجة الدفع خطأ. يرجى الاتصال بنا',
  'DYN.paymentError.desc.later': 'للأسف، تم رفض معالجة الدفع مؤقتاً. يرجى المحاولة مرة أخرى.',
  'tooltip.applicationId': 'معرف التطبيق.',
  'client.extended.missingResource': 'المورد الذي طلبته غير متوفر حالياً. يرجى المحاولة مرة أخرى لاحقاً.',
  'skip.valid': 'خطوات المراجعة التلقائية للخطوات',
  'extension.data': 'بيانات التمديد',
  'attestantAddress': 'عنوان الموثق',
  'attestantEmail': 'البريد الإلكتروني للشاهد',
  'attestantID': 'هوية المصدق',
  'attestantName': 'اسم الموثق',
  'attestantPhone': 'هاتف الموثق',
  'attestantRelation': 'العلاقة مع المشهود له',
  'daysRequested': 'عدد الأيام المطلوبة',
  'tooltip.visaApplicationReference': 'انتقل إلى طلب التأشيرة المرتبط بطلب التمديد هذا',
  'extend.visaReference': 'الطلب المرتبط بطلب التمديد هذا',
  'data.copyOfEntry': 'نسخة من الإدخال',
  'data.departureTicket': 'تذكرة المغادرة',
  'data.attestantDocument': 'وثيقة المصدق',
  'data.affidavitCustody': 'إفادة الحضانة',
  'reasonForExtention': 'سبب التمديد',
  'final.ZWEVISAEXTAB': 'يجب الموافقة على طلب التمديد هذا من قبل الضابط.',
  'zwevisaExtValid': 'تم التحقق من صحة التمديد',
  'zwevisaExtValid.desc': 'تم التحقق من صحة طلب التمديد هذا من قبل الضابط.',
  'zwevisaExtC.review.state': 'في انتظار المراجعة',
  'zwevisaExtC.review.desc': 'طلب التمديد هذا في انتظار المراجعة.',
  'zwevisaExtC.finalReview.desc': 'تمت مراجعة طلب التمديد هذا وهو حالياً في انتظار المراجعة النهائية.',
  'zwevisaExtC.finalReview.state': 'في انتظار المراجعة النهائية',
  'onlyFinalReview': 'هذا الطلب في انتظار المراجعة النهائية.',
  'tooltip.tableLocalUsageUntil': 'يشير تاريخ انتهاء صلاحية الطلب إلى الحد الأقصى لتاريخ انتهاء الإقامة.',
  'error.bad.localUsageUntil': 'يجب أن يكون الحد الأقصى لتاريخ انتهاء الإقامة أقل من تاريخ انتهاء الصلاحية الحالي وبعد اليوم.',
  'none': 'لا',
  'change.password.ad': 'امتلاك حساب دليل نشط، لا يمكنك تغيير كلمة المرور الخاصة بك هنا. لمزيد من المعلومات، يرجى الاتصال بالدعم.',
  'noticePrint.title': 'معلومات الإشعار للزائر المطبوع للعميل',
  'reportingPost': 'وظيفة الإبلاغ',
  'noticePrint.matTooltip': 'معلومات الإشعار الموجه للزائر المطبوع للعميل أثناء عملية تسجيل الوصول',
  'notice.confirm': 'هل أنت متأكد من المعلومات الواردة في الإشعار؟',
  'global.refusePrint': 'اطبع وأرسل',
  'global.nextPrint': 'اطبع وتابع',
  'err.periodFrom.periodFromGreaterThanPeriodTo': 'يجب أن تكون الفترة من قبل الفترة إلى.',
  'payment.reject_reason': 'سبب الرفض',
  'err.fileSize': 'حجم الملف كبير جداً. الحجم الأقصى هو: {الحجم}',
  'document.zafembpass': 'جواز سفر سفارة ZAF',
  'preenroll': 'التسجيل المسبق',
  'screen': 'الفحص',
  'pass': 'جواز السفر',
  'document.pass': 'جواز السفر',
  'document.screen': 'الفحص',
  'payment.ask.print': 'هل الإيصال مطبوع؟',
  'global.no.retry': 'لا (إعادة المحاولة)',
  'print.receipt': 'طباعة الإيصال',
  'tooltip.printReceipt': 'اطبع إيصال (إيصالات) الطلب',
  'ask.printReceipt': 'هل تريد طباعة الإيصال بتاريخ <b>{date}</b>؟',
  'error.printReceipt': 'حدث خطأ أثناء طباعة الإيصال. يرجى المحاولة مرة أخرى.',
  'ask.selectReceipt': 'يرجى تحديد الإيصال الذي تريد طباعته.',
  'operation.OUT': 'تسجيل المغادرة',
  'operation.IN': 'تسجيل الوصول',
  'operation.PAYMENT_FINALIZED': 'تم الدفع',
  'operation.PAYMENT_CREATED': 'تم إنشاء الدفع',
  'operation.PAYMENT_USED_FORCE': 'تم استخدام الدفع',
  'noChoice.selectedReceipt': 'يرجى تحديد إيصال لطباعته.',
  'select.receipt': 'حدد الإيصال',
  'receiptFor.alt': 'إعادة استلام',
  'paymentType': 'نوع الدفع',
  'totalAmount.alt': 'المبلغ الإجمالي',
  'totalAmount': 'المبلغ الإجمالي',
  'date': 'التاريخ',
  'client': 'العميل',
  'desc': 'الوصف',
  'details': 'التفاصيل',
  'client.extended.minUsageNotMet': 'يجب أن يكون تاريخ الصلاحية حتى بعد يوم واحد على الأقل من تاريخ الصلاحية من.',
  'lock': 'القفل',
  'tooltip.tableLockTitle': 'الاستخدام النشط من قبل الضابط (الضباط)',
  'client.extended.uuidNotPaid': 'لم يتم التحقق من صحة الدفع بعد. يرجى التحقق من صحة الدفع قبل المتابعة.',
  'form.operationComments': 'تبرير العملية',
  'borderPass.emit': 'إصدار تصريح مرور الحدود',
  'tooltip.borderPass': 'تصريح الحدود هو وثيقة تسمح للشخص بعبور الحدود. ويُستخدم عندما لا يكون لدى الشخص جواز سفر.',
  'zweexit.title': 'الخروج بدون تأشيرة',
  'borderPass.title': 'تصريح مرور الحدود',
  'print.borderPass': 'طباعة بطاقة الحدود',
  'print.borderPass.ask': 'هل تصريح الحدود مطبوع؟',
  'err.issueDate.afterExpiryDate': 'يجب أن يكون تاريخ الإصدار قبل تاريخ انتهاء الصلاحية.',
  'err.BirthDay.afterExpiryDate': 'يجب أن يكون تاريخ الميلاد قبل تاريخ انتهاء الصلاحية.',
  'err.BirthDay.afterIssueDate': 'يجب أن يكون تاريخ الميلاد قبل تاريخ الإصدار.',
  'apiPnrCollapse': 'تم العثور على PNR',
  'match.name': 'الاسم',
  'match.score.name': 'نتيجة الاسم',
  'match.flightCarrier': 'ناقل جوي',
  'match.flightNumber': 'رقم الرحلة',
  'match.documentType': 'نوع المستند',
  'match.documentNumber': 'عدد المستندات',
  'match.documentIssuer': 'مُصدر الوثيقة',
  'match.timeType': 'نوع الحدث',
  'match.timeDate': 'تاريخ الحدث',
  'match.timeScope': 'نطاق الحدث',
  'match.nationality': 'الجنسية',
  'match.gender': 'الجنس',
  'match.uuid': 'UUID',
  'match.travelerUUID': 'معرّف المسافر UUID',
  'tooltip.apiPnr': 'معلومات PNR التي تم العثور عليها لهذا الشخص.',
  'match.documentIssued': 'تاريخ إصدار الوثيقة',
  'match.placeIssued': 'مكان إصدار الوثيقة',
  'match.documentExpiration': 'تاريخ انتهاء صلاحية الوثيقة',
  'match.documentScore': 'نتيجة المستند',
  'match.timeScore': 'نتيجة الحدث',
  'match.flightOriginDomestic': 'المنشأ المحلي لرحلة الطيران',
  'match.flightOriginIcao': 'منظمة الطيران المدني الدولي (ICAO) لمنشأ الرحلة',
  'match.flightOriginLat': 'خط عرض منشأ الرحلة',
  'match.flightOriginLng': 'خط طول منشأ الرحلة',
  'match.flightOriginIata': 'اتحاد النقل الجوي الدولي (IATA) لمنشأ الرحلة',
  'match.flightOriginCity': 'مدينة منشأ الرحلة',
  'match.flightOriginState': 'حالة أصل الرحلة',
  'match.flightOriginCountry': 'بلد منشأ الرحلة',
  'match.flightOriginContinent': 'قارة منشأ الرحلة',
  'match.flightOriginName': 'اسم منشأ الرحلة',
  'match.flightOriginTimezone': 'المنطقة الزمنية لمنشأ الرحلة',
  'match.flightDestinationDomestic': 'الوجهة المحلية لرحلة الطيران',
  'match.flightDestinationIcao': 'منظمة الطيران المدني الدولي (ICAO) لوجهة الرحلة',
  'match.flightDestinationLat': 'خط عرض وجهة الرحلة',
  'match.flightDestinationLng': 'خط طول وجهة الرحلة',
  'match.flightDestinationIata': 'اتحاد النقل الجوي الدولي (IATA) لوجهة الرحلة',
  'match.flightDestinationCity': 'مدينة وجهة الرحلة',
  'match.flightDestinationState': 'حالة وجهة الرحلة',
  'match.flightDestinationCountry': 'بلد وجهة الرحلة',
  'match.flightDestinationContinent': 'قارة وجهة الرحلة',
  'match.flightDestinationName': 'اسم وجهة الرحلة',
  'match.flightDestinationTimezone': 'المنطقة الزمنية لوجهة الرحلة',
  'match.localDepartureDate': 'تاريخ المغادرة المحلي',
  'match.localDepartureTime': 'وقت المغادرة المحلي',
  'match.localDepartureTotalMinutes': 'إجمالي دقائق المغادرة المحلية',
  'match.localDepartureDay': 'يوم المغادرة المحلي',
  'match.localDepartureZone': 'منطقة المغادرة المحلية',
  'match.airportDepartureDate': 'تاريخ المغادرة من المطار',
  'match.airportDepartureTime': 'وقت المغادرة من المطار',
  'match.airportDepartureTotalMinutes': 'إجمالي دقائق المغادرة من المطار',
  'match.airportDepartureDay': 'يوم المغادرة من المطار',
  'match.airportDepartureZone': 'منطقة المغادرة من المطار',
  'match.utcDepartureDate': 'تاريخ المغادرة بالتوقيت العالمي المنسق (UTC)',
  'match.utcDepartureTime': 'توقيت المغادرة بالتوقيت العالمي المنسق (UTC)',
  'match.utcDepartureTotalMinutes': 'إجمالي دقائق المغادرة بالتوقيت العالمي المنسق UTC',
  'match.utcDepartureDay': 'يوم المغادرة بالتوقيت العالمي المنسق UTC',
  'match.utcDepartureZone': 'منطقة المغادرة بالتوقيت العالمي المنسق UTC',
  'match.originalDeparture': 'المغادرة الأصلية',
  'match.flightDepartureUtcstr': 'مغادرة الرحلة المغادرة بالتوقيت العالمي المنسق (UTC)',
  'match.localArrivalDate': 'تاريخ الوصول المحلي',
  'match.localArrivalTime': 'وقت الوصول المحلي',
  'match.localArrivalTotalMinutes': 'إجمالي دقائق الوصول المحلي',
  'match.localArrivalDay': 'يوم الوصول المحلي',
  'match.localArrivalZone': 'منطقة الوصول المحلية',
  'match.airportArrivalDate': 'تاريخ الوصول إلى المطار',
  'match.airportArrivalTime': 'وقت الوصول إلى المطار',
  'match.airportArrivalTotalMinutes': 'إجمالي دقائق الوصول إلى المطار',
  'match.airportArrivalDay': 'يوم الوصول إلى المطار',
  'match.airportArrivalZone': 'منطقة الوصول إلى المطار',
  'match.utcArrivalDate': 'تاريخ الوصول بالتوقيت العالمي المنسق (UTC)',
  'match.utcArrivalTime': 'وقت الوصول بالتوقيت العالمي المنسق (UTC)',
  'match.utcArrivalTotalMinutes': 'مجموع دقائق الوصول بالتوقيت العالمي المنسق UTC',
  'match.utcArrivalDay': 'يوم الوصول بالتوقيت العالمي المنسق UTC',
  'match.utcArrivalZone': 'منطقة الوصول بالتوقيت العالمي المنسق UTC',
  'match.originalArrival': 'الوصول الأصلي',
  'match.flightArrivalUtcstr': 'وصول الرحلة الوصول بالتوقيت العالمي الموحد للرحلات الجوية',
  'match.flightBound': 'رحلة طيران متجهة إلى',
  'ask.notice': 'طباعة إشعار للزائر أو إشعار تقييد مؤقت',
  'tooltip.checkIn.notice': 'تسجيل دخول الشخص في البلد وطباعة إشعار للزائر أو إشعار تقييد مؤقت.',
  'global.checkIn.notice': 'تسجيل الوصول بإشعار',
  'form.numberPeople': 'عدد الأشخاص المسافرين مع مقدم الطلب',
  'feedbackForm': 'نموذج الملاحظات',
  'form.totalSpend': 'إجمالي الإنفاق خلال فترة الإقامة',
  'countryPermanentResidence': 'بلد الإقامة الدائمة',
  'form.feedbackComments': 'تعليقات إضافية',
  'feedback.submit': 'إرسال الملاحظات',
  'feedback.submitted': 'تم إرسال الملاحظات بنجاح.',
  'total': 'الإجمالي',
  'smartTable.placeId': 'معرّف المكان',
  'smartTable.id': 'بطاقة الهوية',
  'smartTable.userId': 'معرّف المستخدم',
  'smartTable.name': 'الاسم',
  'smartTable.role': 'الدور',
  'smartTable.email': 'البريد الإلكتروني',
  'smartTable.creationDate': 'تاريخ الإنشاء',
  'smartTable.applicationId': 'معرّف التطبيق',
  'smartTable.lock': 'القفل',
  'smartTable.internalReference': 'مرجع المقر الرئيسي',
  'smartTable.nationality': 'الجنسية',
  'smartTable.batchId': 'مرجع التطبيق',
  'smartTable.firstName': 'الاسم الأول',
  'smartTable.lastName': 'اسم العائلة',
  'smartTable.fullName': 'الاسم الكامل',
  'smartTable.passportNumber': 'رقم جواز السفر',
  'smartTable.isUrgent': 'عاجل',
  'smartTable.paymentStatus': 'حالة الطلب',
  'smartTable.price': 'السعر',
  'smartTable.usageAfter': 'صالح من',
  'smartTable.usageUntil': 'صالحة حتى',
  'smartTable.operationId': 'نوع المستند',
  'smartTable.filter.applicationType': 'نوع التطبيق',
  'smartTable.filter.isUrgent': 'عاجل',
  'smartTable.filter.overstay': 'الإقامة الزائدة',
  'smartTable.filter.paymentStatus': 'حالة الطلب',
  'smartTable.filter.paymentExtStatus': 'حالة التمديد',
  'smartTable.filter.createAtStart': 'من',
  'smartTable.filter.createAtEnd': 'إلى',
  'smartTable.filter.sinceDays': 'منذ',
  'smartTable.filter.timeslotStart': 'الفترة الزمنية من',
  'smartTable.filter.timeslotEnd': 'الفترة الزمنية إلى',
  'residencePermit.warning': 'رقم تصريح الإقامة <b>{permitNumber}</b> غير موجود في قاعدة البيانات.<br><br>يرجى التحقق يدويًا من هذا الرقم مقابل التصريح الفعلي للمسافر قبل الموافقة على الدخول.',
  'statusLabel.toConfirm': '(قيد التأكيد)',
  'form.lang.IT': 'Italiano',
  'form.lang.JA': '日本語',
  'form.birthCity': 'مدينة الميلاد',
  'form.eyeColor': 'لون العيون',
  'form.hairColor': 'لون الشعر',
  'form.height': 'الطول',
  'form.occupation': 'المهنة',
  'form.fatherFirstName': 'الاسم الأول للأب',
  'form.fatherLastName': 'اسم العائلة للأب',
  'form.motherFirstName': 'الاسم الأول للأم',
  'form.motherLastName': 'اسم العائلة للأم',
  'form.physical.description': 'الوصف الجسدي',
  'documents.no.documents': 'لم يتم العثور على مستندات لهذا التطبيق',
  'OtherPurpose': 'Other purpose',
  'form.seniority.ownPlace': 'المكان الخاص فقط',
  'form.seniority.allPlaces': 'جميع الأماكن',
  'RegistrationType': 'نوعك',
  'ManagerJobTitle': 'مسمى منصب المدير',
  'BusinessRegistrationNumber': 'رقم تسجيل الشركة',
  'CompanyName': 'اسم الشركة',
  'global.naturalPerson': 'الشخص الطبيعي',
  'global.legalEntity': 'كيان قانوني',
  'registrationType.natural': 'شخص طبيعي',
  'DYN.registrationType.legal': 'كيان قانوني',
  'DYN.GENERAL_MANAGER': 'مدير عام',
  'DYN.PRESIDENT_CEO': 'رئيس ومدير تنفيذي',
  'DYN.HR_DIRECTOR': 'مدير الموارد البشرية',
  'DYN.CONSULAR_CARD': 'بطاقة قنصلية',
  'DYN.NATIONAL_IDENTITY_CARD': 'بطاقة الهوية الوطنية',
  'DYN.PASSPORT': 'جواز سفر',
  'DYN.RESIDENT_CARD': 'بطاقة مقيم',
  'IdentificationDocument': 'وثيقة الهوية',
  'applicant_information': 'معلومات المتقدم',
  'applier_information': 'معلومات مقدم الطلب',
  'DYN.BROTHER': 'أخ',
  'DYN.SISTER': 'أخت',
  'DYN.MOTHER': 'أم',
  'DYN.FATHER': 'أب',
  'DYN.GRANDFATHER': 'جد',
  'DYN.GRANDMOTHER': 'جدة',
  'DYN.HUSBAND': 'زوج',
  'DYN.MARRY': 'زوج/زوجة',
  'DYN.CHILD': 'طفل',
  'DYN.FRIEND': 'صديق',
  'DYN.COUSIN': 'ابن/بنت عم',
  'DYN.FULL_ADOPTION': 'تبني كامل',
  'DYN.SIMPLE_ADOPTION': 'تبني بسيط',
  'DYN.EMPLOYEE': 'موظف',
  'DYN.MYSELF': 'أنا بنفسي',
  'DYN.MODIFICATION': 'تعديل',
  'DYN.DUPLICATE': 'نسخة',
  'DYN.WORKER': 'عامل',
  'DYN.RELIGIOUS': 'ديني',
  'DYN.SPOUSE_TAKEN_CARE_OF': 'زوج/زوجة في الرعاية',
  'DYN.MERCHANTS': 'تجار',
  'DYN.CORPORATION_WORKERS_VOLUNTEERS_FRENCH': 'عمال/متطوعون فرنسيون في شركة',
  'DYN.FRENCH_NATIONAL': 'مواطن فرنسي',
  'DYN.STUDENTS': 'طلاب',
  'DYN.CRAFTSMAN': 'حرفي',
  'DYN.MINOR_UNDER_16': 'قاصر تحت 16 سنة',
  'DYN.WITHDRAWN': 'مسحوب',
  'DYN.MALE': 'ذكر',
  'DYN.FEMALE': 'أنثى',
  'RequestReason': 'سبب الطلب',
  'DYN.LEGAL': 'قانوني',
  'DYN.NATURAL': 'طبيعي',
  'WorkContract': 'عقد عمل',
  'GuardianIdCard': 'بطاقة هوية الوصي',
  'DYN.NEW_REQUEST': 'طلب جديد',
  'DYN.RENEWAL': 'تجديد',
  'DYN.LOST': 'مفقود',
  'NationalId': 'الهوية الوطنية',
  'IdNumber': 'رقم الهوية',
  'BirthEntryNumber': 'رقم قيد الميلاد',
  'NameChanged': 'هل تم تغيير اسمك؟',
  'OriginalName': 'الاسم الأصلي',
  'NameChangedTo': 'تم تغيير الاسم إلى',
  'NameChangeDate': 'تاريخ تغيير الاسم',
  'personal_details_1': 'التفاصيل الشخصية - 1',
  'personal_details_2': 'التفاصيل الشخصية - 2',
  'EyeColor': 'لون العيون',
  'HairColor': 'لون الشعر',
  'VisibleMark': 'علامات مرئية أو خصائص مميزة',
  'MarriageDate': 'تاريخ الزواج',
  'MarriagePlace': 'مكان الزواج',
  'SpouseCitizenship': 'جنسية الزوج/الزوجة',
  'MarriageDivorceOrderNumber': 'رقم شهادة الزواج أو الطلاق',
  'personal_details_3': 'التفاصيل الشخصية - 3',
  'FullName': 'الاسم الكامل',
  'Relationship': 'العلاقة',
  'next_of_kin': 'أقرب الأقارب',
  'declaration': 'إعلان',
  'ZimbabweCitizenship': 'الجنسية الزيمبابوية',
  'global.renewal': 'تجديد',
  'global.newRequest': 'طلب جديد',
  'global.lost': 'مفقود',
  'DYN.BLOND': 'أشقر',
  'DYN.CHESTNUT': 'كستنائي',
  'DYN.BROWN': 'بني',
  'DYN.BLACK': 'أسود',
  'DYN.RED': 'أحمر',
  'DYN.GRAY_WHITE': 'رمادي/أبيض',
  'DYN.OTHER': 'آخر',
  'DYN.BLUE': 'أزرق',
  'DYN.GRAY': 'رمادي',
  'DYN.GREEN': 'أخضر',
  'DYN.HAZEL': 'عسلي',
  'DYN.YES': 'نعم',
  'DYN.NO': 'لا',
  'DYN.NA': 'غير قابل للتطبيق',
  'DYN.SINGLE': 'أعزب',
  'DYN.MARRIED': 'متزوج',
  'DYN.SEPARATED': 'منفصل',
  'DYN.DIVORCED': 'مطلق',
  'DYN.WIDOWED': 'أرمل',
  'DYN.MARRIED_ACCORDING_TO_CUSTOM': 'متزوج حسب العرف',
  'DYN.RELIGIOUSLY_MARRIED': 'متزوج دينياً',
  'MarriageCountry': 'بلد الزواج',
  'NationalityCertificate': 'شهادة الجنسية',
  'MarriageCertificate': 'شهادة الزواج',
  'CitizenshipCertificate': 'شهادة المواطنة',
  'OldPassportOrEmergencyTravelDocument': 'جواز سفر قديم أو وثيقة سفر طارئة',
  'global.N/A': 'غير متوفر',
  'ZimbabwePassportIssued': 'هل تم إصدار جواز سفر زيمبابوي لك من قبل؟',
  'PreviousPassportNumber': 'إذا كانت الإجابة نعم، اذكر رقم جواز السفر',
  'RenounceForeignBirthRight': 'هل تتنازل عن حق المولد الأجنبي لصالح الجنسية الزيمبابوية؟',
  'HoldingForeignPassport': 'هل تحمل جواز سفر أجنبي؟',
  'SurrenderForeignPassport': 'هل تسلم جواز سفرك الأجنبي؟',
  'TrueInformationDeclaration': 'أعلن أن المعلومات المقدمة صحيحة وكاملة ودقيقة على حد علمي.',
  'DYN.YES-VALID': 'نعم - صالح',
  'DYN.YES-EXPIRED': 'نعم - منتهي الصلاحية',
  'DYN.YES-FULL': 'نعم - مكتمل',
  'DYN.YES-LOST': 'نعم - مفقود',
  'Height': 'الطول',
  'IdNumber_desc': '',
  'err.pattern.^[0-9]+$': 'الحقل "{fieldName}" يقبل القيم الرقمية فقط.',
  'err.pattern.^(?:[3-9][0-9]|[12][0-9][0-9]|2[0-4][0-9]|250)$': 'قيمة "{fieldName}" خارج النطاق المقبول!',
  'magicLinkLogin.title': 'تسجيل الدخول بالرابط السحري',
  'magicLinkLogin.description': 'أدخل بريدك الإلكتروني أو رقم هاتفك لتلقي رابط تسجيل الدخول.',
  'magicLinkLogin.email': 'البريد الإلكتروني',
  'magicLinkLogin.phone': 'الهاتف',
  'magicLinkLogin.sendLink': 'إرسال رابط تسجيل الدخول',
  'magicLinkLogin.linkSent': 'تم إرسال الرابط السحري!',
  'magicLinkLogin.checkDevice': 'يرجى التحقق من بريدك الإلكتروني أو هاتفك للحصول على رابط تسجيل الدخول.',
  'magicLinkLogin.sendAnother': 'إرسال رابط آخر',
  'magicLinkLogin.descriptionEmailOnly': 'أدخل عنوان بريدك الإلكتروني لتلقي رابط تسجيل الدخول.',
  'magicLinkLogin.descriptionSmsOnly': 'أدخل رقم هاتفك لتلقي رابط تسجيل الدخول عبر الرسائل القصيرة.',
  'magicLinkLogin.country': 'البلد',
  'magicLinkLogin.selectCountry': 'اختر بلد',
  'magicLinkLogin.checkEmail': 'يرجى التحقق من بريدك الإلكتروني للحصول على رابط تسجيل الدخول.',
  'magicLinkLogin.checkSms': 'يرجى التحقق من هاتفك للحصول على رابط تسجيل الدخول.',
  'magicLinkLogin.backToLogin': 'العودة إلى نموذج تسجيل الدخول',
  'magicLinkLogin.backToSignIn': 'العودة إلى تسجيل الدخول',
  'err.pattern.^0[0-9]{9}$': 'رقم هاتف غير صحيح',
  'err.pattern.^[0-9A-Za-z]{1,50}$': 'يجب أن يحتوي الحقل "{fieldName}" على 50 حرف كحد أقصى.',
  'mother_names_desc': '',
  'father_names_desc': '',
  'form.accountName': 'اسم الحساب',
  'ManagerJobTitleOther': 'يرجى تحديد المسمى الوظيفي',
  'AttestantRelationOther': 'يرجى تحديد العلاقة',
  'RequestReasonOther': 'يرجى تحديد السبب',
  'Status': 'الحالة',
  'StatusOther': 'يرجى تحديد الحالة',
  'CRNNIExpiryDate': 'تاريخ انتهاء رقم الهوية الوطنية CR/NNI',
  'CRNNI': 'رقم CR/NNI',
  'nav.searchFromDocument': 'بحث من الوثيقة',
  'tooltip.nextApplication': 'تحميل الطلب التالي الذي يحتاج إلى معالجة',
  'nextApplication.button': 'معالجة الطلب التالي',
  'error.insufficientPermissions': 'صلاحيات غير كافية للوصول إلى هذه الميزة',
  'nextApplication.noMore': 'لا توجد طلبات أخرى للمعالجة',
  'nextApplication.error': 'خطأ في تحميل الطلب التالي',
  'document.Preview': 'معاينة المستند',
  'DYN.ABIDJAN': 'ABIDJAN',
  'DYN.BOUAKE': 'BOUAKE',
  'DYN.DALOA': 'DALOA',
  'DYN.YAMOUSSOUKRO': 'YAMOUSSOUKRO',
  'DYN.SAN_PEDRO': 'SAN_PEDRO',
  'DYN.KORHOGO': 'KORHOGO',
  'DYN.GAGNOA': 'GAGNOA',
  'DYN.MAN': 'MAN',
  'traveller.history.title': 'سجل المسافر',
  'traveller.history.loading': 'جاري تحميل السجل…',
  'traveller.history.entry_exit': 'دخول / خروج',
  'traveller.history.compliance': 'الامتثال',
  'traveller.history.view_more': 'عرض المزيد',
  'traveller.history.collapse': 'طي',
  'traveller.history.no_records': 'لم يتم العثور على سجلات',
  'traveller.history.records': 'سجلات',
  'traveller.history.user': 'المستخدم',
  'traveller.history.reason': 'السبب',
  'traveller.history.additional_info': 'معلومات إضافية',
  'traveller.history.event.ENTERED_COUNTRY': 'دخول البلد',
  'traveller.history.event.EXITED_COUNTRY': 'مغادرة البلد',
  'traveller.history.event.DEPORTATION_CREATED': 'تم إنشاء الترحيل',
  'traveller.history.event.DEPORTATION_EDITED': 'تم تعديل الترحيل',
  'traveller.history.event.DEPORTATION_APPROVED_BY_SUPERVISOR': 'تمت الموافقة على الترحيل من قبل المشرف',
  'traveller.history.event.DEPORTATION_APPROVED_BY_DIR_OPS': 'تمت الموافقة على الترحيل من قبل مدير العمليات',
  'traveller.history.event.SUCCESSFULLY_DEPORTED': 'تم الترحيل بنجاح',
  'traveller.history.event.DEPORTATION_DECLINED': 'تم رفض الترحيل',
  'traveller.history.event.ADDED_TO_WATCHLIST': 'تمت الإضافة إلى قائمة المراقبة',
  'traveller.history.event.REMOVED_FROM_WATCHLIST': 'تمت الإزالة من قائمة المراقبة',
  'traveller.history.event.PROSECUTION_CREATED': 'تم إنشاء الملاحقة القضائية',
  'traveller.history.event.ADDED_BIOMETRIC': 'تمت إضافة البيانات البيومترية',
  'traveller.history.event.INTERVIEW_CREATED': 'تم إنشاء المقابلة',
  'traveller.history.event.INTERVIEW_EDITED': 'تم تعديل المقابلة',
  'traveller.history.event.REFUGEE_RECORD_CREATED': 'تم إنشاء سجل اللاجئ',
  'traveller.history.event.REFUGEE_RECORD_EDITED': 'تم تعديل سجل اللاجئ',
  'traveller.history.visa': 'تأشيرة',
  'traveller.history.event.VALIDATED': 'تمت الموافقة',
  'traveller.history.event.REFUSED': 'مرفوض',
  'traveller.history.permits': 'التصاريح',
  'traveller.history.permit.ORDINARY_RESIDENCE_PERMIT': 'تصريح إقامة عادي',
  'traveller.history.permit.SPOUSE_RESIDENCE_PERMIT': 'تصريح إقامة الزوج',
  'traveller.history.permit.INVESTOR_RESIDENCE_PERMIT': 'تصريح إقامة مستثمر',
  'traveller.history.permit.STUDENTS_PERMIT': 'تصريح طالب',
  'traveller.history.permit.SCHOLARS_PERMIT': 'تصريح دراسي',
  'traveller.history.permit.TEMPORARY_EMPLOYMENT_PERMIT': 'تصريح عمل مؤقت',
  'traveller.history.permit.AUTHORITY_TO_WORK': 'تصريح عمل',
  'traveller.history.permit.RESUMPTION': 'استئناف',
  'traveller.history.permit.DUAL_CITIZENSHIP': 'جنسية مزدوجة',
  'traveller.history.permit.REINSTATEMENT': 'إعادة تعيين',
  'traveller.history.permit.applicationType': 'نوع الطلب',
  'traveller.history.permit.appType.INITIAL': 'أولي',
  'traveller.history.permit.appType.EXTENSION': 'تمديد',
  'traveller.history.permit.appType.PERMANENT': 'دائم',
  'traveller.history.permit.status.REQUESTED': 'مطلوب',
  'traveller.history.permit.status.APPROVED': 'موافق عليه',
  'traveller.history.permit.status.REJECTED': 'مرفوض',
  'traveller.history.permit.issueDate': 'تاريخ الإصدار',
  'traveller.history.permit.expiryDate': 'تاريخ الانتهاء',
  'showcase.heroTitle': 'سريع، آمن و<em>رقمي</em><br/>تجربة التأشيرة الإلكترونية.',
  'showcase.heroSubtitle': 'تقدم بطلبك وتحقق وسافر في دقائق. {name} يجمع بين الهوية البيومترية ومحرك قرارات حكومي — حتى تصل موافقتك قبل وصولك.',
  'showcase.heroSubtitle.evisa': 'تقدم بطلبك وتحقق وسافر في دقائق. {name} يجمع بين الهوية البيومترية ومحرك قرارات حكومي — حتى تصل موافقتك قبل وصولك.',
  'showcase.heroSubtitle.passport_idCard_residencePermit': 'قدم طلبك للحصول على جواز سفر أو بطاقة هوية وطنية أو تصريح إقامة عبر الإنترنت. {name} يعالج ويتابع كل طلب في الوقت الفعلي، من التقديم إلى التسليم.',
  'showcase.heroSubtitle.passport_idCard': 'قدم طلبك للحصول على جواز سفر أو بطاقة هوية وطنية عبر الإنترنت. {name} يعالج ويتابع كل طلب في الوقت الفعلي.',
  'showcase.heroSubtitle.passport': 'قدم طلبك للحصول على جواز سفر عبر الإنترنت. {name} يعالج ويتابع كل طلب في الوقت الفعلي.',
  'showcase.heroSubtitle.idCard': 'قدم طلبك للحصول على بطاقة الهوية الوطنية عبر الإنترنت. {name} يعالج ويتابع كل طلب في الوقت الفعلي.',
  'showcase.heroSubtitle.residencePermit': 'قدم طلبك للحصول على تصريح إقامة عبر الإنترنت. {name} يعالج ويتابع كل طلب في الوقت الفعلي.',
  'showcase.heroSubtitle.passport_residencePermit': 'قدم طلبك للحصول على جواز سفر أو تصريح إقامة عبر الإنترنت. {name} يعالج ويتابع كل طلب في الوقت الفعلي.',
  'showcase.heroSubtitle.idCard_residencePermit': 'قدم طلبك للحصول على بطاقة هوية أو تصريح إقامة عبر الإنترنت. {name} يعالج ويتابع كل طلب في الوقت الفعلي.',
  'showcase.heroCta1': 'التقدم للتأشيرة الإلكترونية',
  'showcase.heroCta2': 'تتبع الطلب',
  'showcase.flowTitleMain': 'أربع خطوات.<br/><em>بلا طوابير.</em>',
  'showcase.flowTitleSub': 'طلب يرافقك في سفرك.',
  'showcase.flowSubtitle': '{name} ينسق الأجزاء الأربعة من طلبك في حركة سلسة واحدة — ليتولى النظام الأوراق بينما تحزم حقائبك.',
  'showcase.ctaTitle': 'ابدأ رحلتك<br/><em>رقمياً.</em>',
  'showcase.ctaSubtitle': 'طلب واحد. تأشيرة إلكترونية في جيبك وقرار يصل قبل وصولك.',
  'showcase.step1.label': 'إنشاء الطلب',
  'showcase.step1.paneTitle': 'أدخل بياناتك',
  'showcase.step1.paneDesc': 'الوجهة وتواريخ السفر وغرض الزيارة ومنفذ الدخول…',
  'showcase.step2.label': 'رفع المستندات',
  'showcase.step2.paneTitle': 'ارفع جواز سفرك',
  'showcase.step2.paneDesc': 'مسح جواز السفر وقراءة MRZ واستخراج البيانات الفوري…',
  'showcase.step3.label': 'التحقق البيومتري',
  'showcase.step3.paneTitle': 'كشف الحيوية ومطابقة الوجه',
  'showcase.step3.paneDesc': 'فحص الحيوية ومطابقة الوجه وفحص العقوبات…',
  'showcase.step4.label': 'موافقة فورية',
  'showcase.step4.paneTitle': 'معتمد وجاهز للحدود',
  'showcase.step4.paneDesc': 'تأشيرتك الإلكترونية موقعة ومختومة ومزامنة مع محفظتك…',
  'showcase.stat1.value': 'مشفر',
  'showcase.stat1.label': 'من طرف إلى طرف',
  'showcase.stat2.value': 'معتمد',
  'showcase.stat2.label': 'منصة آمنة',
  'showcase.portalType': 'بوابة التأشيرة الإلكترونية',
  'showcase.tl.step1': 'الهوية',
  'showcase.tl.step3': 'القرار',
  'showcase.tl.step4': 'السفر',
  'showcase.tl.step2': 'المستندات',
  'showcase.evisa.ministry': 'وزارة الخارجية',
  'showcase.marquee.issuedBy': 'صادر من جهات سيادية',
  'showcase.marquee.biometric': 'بيومتري',
  'showcase.marquee.secured': 'محمي',
  'showcase.marquee.borderReady': 'جاهز للحدود في دقائق',
  'showcase.marquee.encrypted': 'تشفير من طرف إلى طرف',
  'showcase.marquee.eSeal': 'ختم إلكتروني مؤهل',
  'showcase.marquee.realtime': 'تتبع في الوقت الفعلي',
  'showcase.annot.mrz': 'تم التحقق من MRZ',
  'showcase.annot.biometric': 'بيومتري',
  'showcase.annot.issued': 'صادر',
  'showcase.annot.secured': 'محمي',
  'showcase.howItWorks': 'كيف يعمل',
  'showcase.signIn': 'تسجيل الدخول إلى حسابي',
  'showcase.scroll': 'التمرير',
  'showcase.permit.badge': 'مقيم',
  'showcase.permit.title': 'تصريح',
  'showcase.permit.name': 'بطاقة الإقامة',
  'finger.thumb': 'الإبهام',
  'finger.index': 'السبابة',
  'finger.middle': 'الإصبع الأوسط',
  'finger.ring': 'خاتم الإصبع',
  'finger.little': 'الإصبع الصغير',
  'finger.missing': 'مفقود',
  'hand.left': 'اليد اليسرى',
  'hand.right': 'اليد اليمنى',
  'fingerprints': 'بصمات الأصابع',
  'finger.thumbs': 'الإبهام',
  'fingers.missing': 'الأصابع المفقودة',
  'signature': 'التوقيع',
  'print.withdrawal.date': 'تاريخ الاستلام',
  'trips.helper': 'انقر لعرض/تنزيل رمز QR',
  'addFingerprint': 'إضافة البصمة',
  'all.supervisions': 'جميع مراجعات الإشراف',
  'apipnr': 'API-PNR',
  'approveOrRefuse': 'الموافقة أو الرفض',
  'ask.refuseCamera': 'الرفض بالكاميرا',
  'ask.revertConsume': 'هل أنت متأكد من أنك تريد إلغاء هذا الحدث؟',
  'cancelApplication': 'إلغاء الطلب',
  'changeFingerprint': 'تغيير البصمة',
  'colorMode': 'وضع الألوان',
  'datePrinted': 'تاريخ الطباعة',
  'defaultPrinter': 'الطابعة الافتراضية',
  'deportedComment': 'سبب حالة الترحيل',
  'draft.cancelled': 'تم إلغاء الطلب بنجاح',
  'DYN.APPROVAL_LETTER': 'خطاب الموافقة',
  'DYN.RECEIPT': 'الإيصال',
  'DYN.REFUSAL': 'الرفض',
  'DYN.RESTRICTION': 'التقييد',
  'DYN.SINGLE_DOCUMENT': 'مستند مقدم الطلب',
  'err.externalId.mustBeDifferent': 'يجب أن يكون مختلفاً عن السابق',
  'error.printSticker': 'حدث خطأ أثناء طباعة الملصق.',
  'error.revertConsume': 'حدث خطأ أثناء إلغاء الحدث. يرجى المحاولة مرة أخرى.',
  'EXTENSIONS': 'التمديدات',
  'forceComparison.hide': 'إخفاء المقارنة مع المستند الممسوح ضوئياً',
  'forceComparison.show': 'إظهار المقارنة مع المستند الممسوح ضوئياً',
  'form.ad': 'البريد الإلكتروني/اسم المستخدم',
  'form.addressZimbabwe': 'عنوان المضيف',
  'global.refuseFingerPrint': 'الرفض بالبصمة',
  'hideFullDatas': 'إخفاء جميع المستندات',
  'otherState.confirm': 'لقد تحققت من المستند',
  'payAttention': 'سأنتبه',
  'paymentReference.ask.edit': 'يرجى إدخال مرجع الدفع الجديد',
  'paymentReference.error.edit': 'حدث خطأ أثناء تحديث مرجع الدفع. يرجى المحاولة مرة أخرى.',
  'print.date': 'تاريخ الطباعة',
  'printSettings': 'إعدادات الطباعة',
  'reload.printerList': 'إعادة تحميل قائمة الطابعات',
  'request.askSupervisorReview.error': 'حدث خطأ أثناء مراجعة الطلب. يرجى المحاولة مرة أخرى.',
  'request.do_supervisor_review': 'مراجعة من قبل المشرف',
  'revert.consume': 'سبب الإلغاء',
  'scan.addFingerprint.error': 'حدث خطأ أثناء إضافة البصمة. يرجى المحاولة مرة أخرى.',
  'SHOWCASE.COMMON.ALL_RIGHTS': 'جميع الحقوق محفوظة.',
  'showFullDatas': 'عرض جميع المستندات',
  'sure': 'نعم، أنا متأكد',
  'tooltip.transitRegister': 'تسجيل عبور الشخص',
  'UsageUntil': 'صالحة حتى',
  'watchlist': 'قائمة المراقبة'
};
